import {IItem, Item} from '../../app/model/item';

export const itemsArray: IItem[] =
  [
    {
      'name': 'Acorn',
      'nameID': 'AcornItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 7,
      'yPos': 12
    },
    {
      'name': 'Acorn Powder',
      'nameID': 'AcornPowderItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 2,
      'yPos': 57
    },
    {
      'name': 'Adorned Ashlar Basalt Bench',
      'nameID': 'AdornedAshlarBasaltBenchItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Basalt Chair',
      'nameID': 'AdornedAshlarBasaltChairItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Basalt Table',
      'nameID': 'AdornedAshlarBasaltTableItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Gneiss Bench',
      'nameID': 'AdornedAshlarGneissBenchItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Gneiss Chair',
      'nameID': 'AdornedAshlarGneissChairItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Gneiss Table',
      'nameID': 'AdornedAshlarGneissTableItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Granite Bench',
      'nameID': 'AdornedAshlarGraniteBenchItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Granite Chair',
      'nameID': 'AdornedAshlarGraniteChairItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Granite Table',
      'nameID': 'AdornedAshlarGraniteTableItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Limestone Bench',
      'nameID': 'AdornedAshlarLimestoneBenchItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Limestone Chair',
      'nameID': 'AdornedAshlarLimestoneChairItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Limestone Table',
      'nameID': 'AdornedAshlarLimestoneTableItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Sandstone Bench',
      'nameID': 'AdornedAshlarSandstoneBenchItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Sandstone Chair',
      'nameID': 'AdornedAshlarSandstoneChairItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Sandstone Table',
      'nameID': 'AdornedAshlarSandstoneTableItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Shale Bench',
      'nameID': 'AdornedAshlarShaleBenchItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Shale Chair',
      'nameID': 'AdornedAshlarShaleChairItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Shale Table',
      'nameID': 'AdornedAshlarShaleTableItem',
      'tag': false
    },
    {
      'name': 'Adorned Ashlar Stone Bench',
      'nameID': 'AdornedAshlarStoneBenchItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 14,
      'yPos': 15
    },
    {
      'name': 'Adorned Ashlar Stone Chair',
      'nameID': 'AdornedAshlarStoneChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 13,
      'yPos': 15
    },
    {
      'name': 'Adorned Ashlar Stone Table',
      'nameID': 'AdornedAshlarStoneTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 15,
      'yPos': 15
    },
    {
      'name': 'Advanced Baking Upgrade',
      'nameID': 'AdvancedBakingUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 28,
      'yPos': 31
    },
    {
      'name': 'Advanced Carpentry Table',
      'nameID': 'AdvancedCarpentryTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 11,
      'yPos': 12
    },
    {
      'name': 'Advanced Circuit',
      'nameID': 'AdvancedCircuitItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 5,
      'yPos': 14
    },
    {
      'name': 'Advanced Combustion Engine',
      'nameID': 'AdvancedCombustionEngineItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 1,
      'yPos': 11
    },
    {
      'name': 'Advanced Cooking Upgrade',
      'nameID': 'AdvancedCookingUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 30,
      'yPos': 31
    },
    {
      'name': 'Advanced Masonry Table',
      'nameID': 'AdvancedMasonryTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 10,
      'yPos': 12
    },
    {
      'name': 'Advanced Masonry Upgrade',
      'nameID': 'AdvancedMasonryUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 32,
      'yPos': 31
    },
    {
      'name': 'Advanced Research',
      'nameID': 'AdvancedResearch',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 15,
      'yPos': 6
    },
    {
      'name': 'Advanced Smelting Upgrade',
      'nameID': 'AdvancedSmeltingUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 34,
      'yPos': 31
    },
    {
      'name': 'Advanced Tailoring Table',
      'nameID': 'AdvancedTailoringTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 5,
      'yPos': 13
    },
    {
      'name': 'Advanced Upgrade 1',
      'nameID': 'AdvancedUpgradeLvl1Item',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 4,
      'yPos': 0
    },
    {
      'name': 'Advanced Upgrade 2',
      'nameID': 'AdvancedUpgradeLvl2Item',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 5,
      'yPos': 0
    },
    {
      'name': 'Advanced Upgrade 3',
      'nameID': 'AdvancedUpgradeLvl3Item',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 6,
      'yPos': 0
    },
    {
      'name': 'Advanced Upgrade 4',
      'nameID': 'AdvancedUpgradeLvl4Item',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 7,
      'yPos': 0
    },
    {
      'name': 'Agave Leaves',
      'nameID': 'AgaveLeavesItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 6,
      'yPos': 2
    },
    {
      'name': 'Agave Seed',
      'nameID': 'AgaveSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 5,
      'yPos': 1
    },
    {
      'name': 'Agouti Carcass',
      'nameID': 'AgoutiCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 7,
      'yPos': 5
    },
    {
      'name': 'Agouti Enchiladas',
      'nameID': 'AgoutiEnchiladasItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 13,
      'yPos': 2
    },
    {
      'name': 'Agriculture Research Paper Advanced',
      'nameID': 'AgricultureResearchPaperAdvancedItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 11,
      'yPos': 4
    },
    {
      'name': 'Agriculture Research Paper Modern',
      'nameID': 'AgricultureResearchPaperModernItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 12,
      'yPos': 4
    },
    {
      'name': 'Alligator Carcass',
      'nameID': 'AlligatorCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 8,
      'yPos': 5
    },
    {
      'name': 'Amanita Mushroom Spores',
      'nameID': 'AmanitaMushroomSporesItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 53,
      'yPos': 55
    },
    {
      'name': 'Amanita Mushrooms',
      'nameID': 'AmanitaMushroomsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 13,
      'yPos': 8
    },
    {
      'name': 'Amendments',
      'nameID': 'AmendmentsItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 0,
      'yPos': 11
    },
    {
      'name': 'Animal',
      'nameID': 'Animal',
      'tag': true
    },
    {
      'name': 'Anvil',
      'nameID': 'AnvilItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 5,
      'yPos': 11
    },
    {
      'name': 'Arctic Willow Seed',
      'nameID': 'ArcticWillowSeedItem',
      'tag': false
    },
    {
      'name': 'Arrastra',
      'nameID': 'ArrastraItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 5,
      'yPos': 8
    },
    {
      'name': 'Arrow',
      'nameID': 'ArrowItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 9,
      'yPos': 14
    },
    {
      'name': 'Ashlar Basalt',
      'nameID': 'AshlarBasaltItem',
      'tag': false
    },
    {
      'name': 'Ashlar Basalt Bench',
      'nameID': 'AshlarBasaltBenchItem',
      'tag': false
    },
    {
      'name': 'Ashlar Basalt Chair',
      'nameID': 'AshlarBasaltChairItem',
      'tag': false
    },
    {
      'name': 'Ashlar Basalt Door',
      'nameID': 'AshlarBasaltDoorItem',
      'tag': false
    },
    {
      'name': 'Ashlar Basalt Fireplace',
      'nameID': 'AshlarBasaltFireplaceItem',
      'tag': false
    },
    {
      'name': 'Ashlar Basalt Table',
      'nameID': 'AshlarBasaltTableItem',
      'tag': false
    },
    {
      'name': 'Ashlar Gneiss',
      'nameID': 'AshlarGneissItem',
      'tag': false
    },
    {
      'name': 'Ashlar Gneiss Bench',
      'nameID': 'AshlarGneissBenchItem',
      'tag': false
    },
    {
      'name': 'Ashlar Gneiss Chair',
      'nameID': 'AshlarGneissChairItem',
      'tag': false
    },
    {
      'name': 'Ashlar Gneiss Door',
      'nameID': 'AshlarGneissDoorItem',
      'tag': false
    },
    {
      'name': 'Ashlar Gneiss Fireplace',
      'nameID': 'AshlarGneissFireplaceItem',
      'tag': false
    },
    {
      'name': 'Ashlar Gneiss Table',
      'nameID': 'AshlarGneissTableItem',
      'tag': false
    },
    {
      'name': 'Ashlar Granite',
      'nameID': 'AshlarGraniteItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_1.webp',
      'xPos': 2,
      'yPos': 49
    },
    {
      'name': 'Ashlar Granite Bench',
      'nameID': 'AshlarGraniteBenchItem',
      'tag': false
    },
    {
      'name': 'Ashlar Granite Chair',
      'nameID': 'AshlarGraniteChairItem',
      'tag': false
    },
    {
      'name': 'Ashlar Granite Door',
      'nameID': 'AshlarGraniteDoorItem',
      'tag': false
    },
    {
      'name': 'Ashlar Granite Fireplace',
      'nameID': 'AshlarGraniteFireplaceItem',
      'tag': false
    },
    {
      'name': 'Ashlar Granite Table',
      'nameID': 'AshlarGraniteTableItem',
      'tag': false
    },
    {
      'name': 'Ashlar Large Basalt Fountain',
      'nameID': 'AshlarLargeBasaltFountainItem',
      'tag': false
    },
    {
      'name': 'Ashlar Large Gneiss Fountain',
      'nameID': 'AshlarLargeGneissFountainItem',
      'tag': false
    },
    {
      'name': 'Ashlar Large Granite Fountain',
      'nameID': 'AshlarLargeGraniteFountainItem',
      'tag': false
    },
    {
      'name': 'Ashlar Large Limestone Fountain',
      'nameID': 'AshlarLargeLimestoneFountainItem',
      'tag': false
    },
    {
      'name': 'Ashlar Large Sandstone Fountain',
      'nameID': 'AshlarLargeSandstoneFountainItem',
      'tag': false
    },
    {
      'name': 'Ashlar Large Shale Fountain',
      'nameID': 'AshlarLargeShaleFountainItem',
      'tag': false
    },
    {
      'name': 'Ashlar Large Stone Fountain',
      'nameID': 'AshlarLargeStoneFountainItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 11,
      'yPos': 15
    },
    {
      'name': 'Ashlar Limestone',
      'nameID': 'AshlarLimestoneItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 13,
      'yPos': 7
    },
    {
      'name': 'Ashlar Limestone Bench',
      'nameID': 'AshlarLimestoneBenchItem',
      'tag': false
    },
    {
      'name': 'Ashlar Limestone Chair',
      'nameID': 'AshlarLimestoneChairItem',
      'tag': false
    },
    {
      'name': 'Ashlar Limestone Door',
      'nameID': 'AshlarLimestoneDoorItem',
      'tag': false
    },
    {
      'name': 'Ashlar Limestone Fireplace',
      'nameID': 'AshlarLimestoneFireplaceItem',
      'tag': false
    },
    {
      'name': 'Ashlar Limestone Table',
      'nameID': 'AshlarLimestoneTableItem',
      'tag': false
    },
    {
      'name': 'Ashlar Sandstone',
      'nameID': 'AshlarSandstoneItem',
      'tag': false
    },
    {
      'name': 'Ashlar Sandstone Bench',
      'nameID': 'AshlarSandstoneBenchItem',
      'tag': false
    },
    {
      'name': 'Ashlar Sandstone Chair',
      'nameID': 'AshlarSandstoneChairItem',
      'tag': false
    },
    {
      'name': 'Ashlar Sandstone Door',
      'nameID': 'AshlarSandstoneDoorItem',
      'tag': false
    },
    {
      'name': 'Ashlar Sandstone Fireplace',
      'nameID': 'AshlarSandstoneFireplaceItem',
      'tag': false
    },
    {
      'name': 'Ashlar Sandstone Table',
      'nameID': 'AshlarSandstoneTableItem',
      'tag': false
    },
    {
      'name': 'Ashlar Shale',
      'nameID': 'AshlarShaleItem',
      'tag': false
    },
    {
      'name': 'Ashlar Shale Bench',
      'nameID': 'AshlarShaleBenchItem',
      'tag': false
    },
    {
      'name': 'Ashlar Shale Chair',
      'nameID': 'AshlarShaleChairItem',
      'tag': false
    },
    {
      'name': 'Ashlar Shale Door',
      'nameID': 'AshlarShaleDoorItem',
      'tag': false
    },
    {
      'name': 'Ashlar Shale Fireplace',
      'nameID': 'AshlarShaleFireplaceItem',
      'tag': false
    },
    {
      'name': 'Ashlar Shale Table',
      'nameID': 'AshlarShaleTableItem',
      'tag': false
    },
    {
      'name': 'Ashlar Small Basalt Fountain',
      'nameID': 'AshlarSmallBasaltFountainItem',
      'tag': false
    },
    {
      'name': 'Ashlar Small Gneiss Fountain',
      'nameID': 'AshlarSmallGneissFountainItem',
      'tag': false
    },
    {
      'name': 'Ashlar Small Granite Fountain',
      'nameID': 'AshlarSmallGraniteFountainItem',
      'tag': false
    },
    {
      'name': 'Ashlar Small Limestone Fountain',
      'nameID': 'AshlarSmallLimestoneFountainItem',
      'tag': false
    },
    {
      'name': 'Ashlar Small Sandstone Fountain',
      'nameID': 'AshlarSmallSandstoneFountainItem',
      'tag': false
    },
    {
      'name': 'Ashlar Small Shale Fountain',
      'nameID': 'AshlarSmallShaleFountainItem',
      'tag': false
    },
    {
      'name': 'Ashlar Small Stone Fountain',
      'nameID': 'AshlarSmallStoneFountainItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 12,
      'yPos': 15
    },
    {
      'name': 'Ashlar Stone',
      'nameID': 'AshlarStone',
      'tag': true,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 13,
      'yPos': 7
    },
    {
      'name': 'Ashlar Stone Bench',
      'nameID': 'AshlarStoneBenchItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 14,
      'yPos': 15
    },
    {
      'name': 'Ashlar Stone Chair',
      'nameID': 'AshlarStoneChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 13,
      'yPos': 15
    },
    {
      'name': 'Ashlar Stone Door',
      'nameID': 'AshlarStoneDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 10,
      'yPos': 15
    },
    {
      'name': 'Ashlar Stone Fireplace',
      'nameID': 'AshlarStoneFireplaceItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 5,
      'yPos': 15
    },
    {
      'name': 'Ashlar Stone Table',
      'nameID': 'AshlarStoneTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 15,
      'yPos': 15
    },
    {
      'name': 'Asphalt Concrete',
      'nameID': 'AsphaltConcreteItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 15,
      'yPos': 6
    },
    {
      'name': 'Assembly Line',
      'nameID': 'AssemblyLineItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 6,
      'yPos': 6
    },
    {
      'name': 'Automatic Loom',
      'nameID': 'AutomaticLoomItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 4,
      'yPos': 13
    },
    {
      'name': 'Autumn Stew',
      'nameID': 'AutumnStewItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 5,
      'yPos': 4
    },
    {
      'name': 'Axe',
      'nameID': 'AxeItem',
      'tag': false
    },
    {
      'name': 'Baked Agave',
      'nameID': 'BakedAgaveItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 5,
      'yPos': 3
    },
    {
      'name': 'Baked Beet',
      'nameID': 'BakedBeetItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 10,
      'yPos': 1
    },
    {
      'name': 'Baked Corn',
      'nameID': 'BakedCornItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 5,
      'yPos': 2
    },
    {
      'name': 'Baked Heart Of Palm',
      'nameID': 'BakedHeartOfPalmItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 14,
      'yPos': 2
    },
    {
      'name': 'Baked Meat',
      'nameID': 'BakedMeatItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 11,
      'yPos': 9
    },
    {
      'name': 'Baked Roast',
      'nameID': 'BakedRoastItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 1,
      'yPos': 14
    },
    {
      'name': 'Baked Taro',
      'nameID': 'BakedTaroItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 0,
      'yPos': 1
    },
    {
      'name': 'Baked Tomato',
      'nameID': 'BakedTomatoItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 11,
      'yPos': 1
    },
    {
      'name': 'Baked Vegetable',
      'nameID': 'BakedVegetable',
      'tag': true,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 6,
      'yPos': 2
    },
    {
      'name': 'Bakery Oven',
      'nameID': 'BakeryOvenItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 2,
      'yPos': 12
    },
    {
      'name': 'Baking Upgrade',
      'nameID': 'BakingUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 44,
      'yPos': 31
    },
    {
      'name': 'Ballot Box',
      'nameID': 'BallotBoxItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 2,
      'yPos': 11
    },
    {
      'name': 'Bandana',
      'nameID': 'BandanaItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 1,
      'yPos': 4
    },
    {
      'name': 'Banh Xeo',
      'nameID': 'BanhXeoItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 8,
      'yPos': 2
    },
    {
      'name': 'Bank',
      'nameID': 'BankItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 13,
      'yPos': 2
    },
    {
      'name': 'Bannock',
      'nameID': 'BannockItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 15,
      'yPos': 4
    },
    {
      'name': 'Barrel',
      'nameID': 'BarrelItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 14,
      'yPos': 13
    },
    {
      'name': 'Barrel Cactus Seed',
      'nameID': 'BarrelCactusSeedItem',
      'tag': false
    },
    {
      'name': 'Basalt',
      'nameID': 'BasaltItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 8,
      'yPos': 6
    },
    {
      'name': 'Basic Backpack',
      'nameID': 'BasicBackpackItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 8,
      'yPos': 3
    },
    {
      'name': 'Basic Circuit',
      'nameID': 'BasicCircuitItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 10,
      'yPos': 11
    },
    {
      'name': 'Basic Engineering Upgrade',
      'nameID': 'BasicEngineeringUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 46,
      'yPos': 31
    },
    {
      'name': 'Basic Research',
      'nameID': 'BasicResearch',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 0,
      'yPos': 7
    },
    {
      'name': 'Basic Salad',
      'nameID': 'BasicSaladItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 4,
      'yPos': 9
    },
    {
      'name': 'Basic Upgrade 1',
      'nameID': 'BasicUpgradeLvl1Item',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Basic Upgrade 2',
      'nameID': 'BasicUpgradeLvl2Item',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 1,
      'yPos': 0
    },
    {
      'name': 'Basic Upgrade 3',
      'nameID': 'BasicUpgradeLvl3Item',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 2,
      'yPos': 0
    },
    {
      'name': 'Basic Upgrade 4',
      'nameID': 'BasicUpgradeLvl4Item',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 3,
      'yPos': 0
    },
    {
      'name': 'Bass',
      'nameID': 'BassItem',
      'tag': false
    },
    {
      'name': 'Bathtub',
      'nameID': 'BathtubItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 2,
      'yPos': 14
    },
    {
      'name': 'Bean Paste',
      'nameID': 'BeanPasteItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 9,
      'yPos': 57
    },
    {
      'name': 'Bean Sprout',
      'nameID': 'BeanSproutItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 0,
      'yPos': 2
    },
    {
      'name': 'Beans',
      'nameID': 'BeansItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 10,
      'yPos': 4
    },
    {
      'name': 'Bear S U P R E M E',
      'nameID': 'BearSUPREMEItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 9,
      'yPos': 9
    },
    {
      'name': 'Bearclaw',
      'nameID': 'BearclawItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 9,
      'yPos': 8
    },
    {
      'name': 'Bearpack',
      'nameID': 'BearpackItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 5,
      'yPos': 7
    },
    {
      'name': 'Beet',
      'nameID': 'BeetItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 8,
      'yPos': 4
    },
    {
      'name': 'Beet Campfire Salad',
      'nameID': 'BeetCampfireSaladItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 8,
      'yPos': 2
    },
    {
      'name': 'Beet Greens',
      'nameID': 'BeetGreensItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 1,
      'yPos': 1
    },
    {
      'name': 'Beet Seed',
      'nameID': 'BeetSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 15,
      'yPos': 57
    },
    {
      'name': 'Berry Extract Fertilizer',
      'nameID': 'BerryExtractFertilizerItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 0,
      'yPos': 53
    },
    {
      'name': 'Big Backpack',
      'nameID': 'BigBackpackItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 4,
      'yPos': 7
    },
    {
      'name': 'Big Bluestem Seed',
      'nameID': 'BigBluestemSeedItem',
      'tag': false
    },
    {
      'name': 'Bighorn Carcass',
      'nameID': 'BighornCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 0,
      'yPos': 8
    },
    {
      'name': 'Biodiesel',
      'nameID': 'BiodieselItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 6,
      'yPos': 11
    },
    {
      'name': 'Birch Log',
      'nameID': 'BirchLogItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 14,
      'yPos': 11
    },
    {
      'name': 'Birch Seed',
      'nameID': 'BirchSeedItem',
      'tag': false
    },
    {
      'name': 'Bison Carcass',
      'nameID': 'BisonCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 1,
      'yPos': 8
    },
    {
      'name': 'Bison Chow Fun',
      'nameID': 'BisonChowFunItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 9,
      'yPos': 2
    },
    {
      'name': 'Bison Mount',
      'nameID': 'BisonMountItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 8,
      'yPos': 14
    },
    {
      'name': 'Blast Furnace',
      'nameID': 'BlastFurnaceItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 7,
      'yPos': 10
    },
    {
      'name': 'Block',
      'nameID': 'Block',
      'tag': true
    },
    {
      'name': 'Blood Meal Fertilizer',
      'nameID': 'BloodMealFertilizerItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 6,
      'yPos': 53
    },
    {
      'name': 'Bloomery',
      'nameID': 'BloomeryItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 12,
      'yPos': 10
    },
    {
      'name': 'Blue Shark',
      'nameID': 'BlueSharkItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 3,
      'yPos': 7
    },
    {
      'name': 'Board',
      'nameID': 'BoardItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 10,
      'yPos': 13
    },
    {
      'name': 'Board',
      'nameID': 'WoodBoard',
      'tag': true,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 10,
      'yPos': 13
    },
    {
      'name': 'Board Of Elections',
      'nameID': 'BoardOfElectionsItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 5,
      'yPos': 10
    },
    {
      'name': 'Boiled Grains',
      'nameID': 'BoiledGrainsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 13,
      'yPos': 9
    },
    {
      'name': 'Boiled Rice',
      'nameID': 'BoiledRiceItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 5,
      'yPos': 9
    },
    {
      'name': 'Boiled Sausage',
      'nameID': 'BoiledSausageItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 5,
      'yPos': 12
    },
    {
      'name': 'Boiler',
      'nameID': 'BoilerItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 10,
      'yPos': 6
    },
    {
      'name': 'Bolete Mushroom Spores',
      'nameID': 'BoleteMushroomSporesItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 10,
      'yPos': 55
    },
    {
      'name': 'Bolete Mushrooms',
      'nameID': 'BoleteMushroomsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 12,
      'yPos': 8
    },
    {
      'name': 'Bookshelf',
      'nameID': 'BookshelfItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 11,
      'yPos': 1
    },
    {
      'name': 'Bow',
      'nameID': 'BowItem',
      'tag': false
    },
    {
      'name': 'Brazier',
      'nameID': 'BrazierItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 13,
      'yPos': 3
    },
    {
      'name': 'Bread',
      'nameID': 'BreadItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 1,
      'yPos': 15
    },
    {
      'name': 'Bread',
      'nameID': 'Bread',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 11,
      'yPos': 3
    },
    {
      'name': 'Brick',
      'nameID': 'BrickItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 9,
      'yPos': 11
    },
    {
      'name': 'Brick Fireplace',
      'nameID': 'BrickFireplaceItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 5,
      'yPos': 15
    },
    {
      'name': 'Builder Boots',
      'nameID': 'BuilderBootsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 2,
      'yPos': 1
    },
    {
      'name': 'Builder Gloves',
      'nameID': 'BuilderGlovesItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 3,
      'yPos': 1
    },
    {
      'name': 'Builder Helmet',
      'nameID': 'BuilderHelmetItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 1,
      'yPos': 1
    },
    {
      'name': 'Builder Overalls',
      'nameID': 'BuilderOverallsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 15,
      'yPos': 0
    },
    {
      'name': 'Builder Shirt',
      'nameID': 'BuilderShirtItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 0,
      'yPos': 1
    },
    {
      'name': 'Bullrush Seed',
      'nameID': 'BullrushSeedItem',
      'tag': false
    },
    {
      'name': 'Bunchgrass Seed',
      'nameID': 'BunchgrassSeedItem',
      'tag': false
    },
    {
      'name': 'Butchery Table',
      'nameID': 'ButcheryTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 13,
      'yPos': 10
    },
    {
      'name': 'Butchery Upgrade',
      'nameID': 'ButcheryUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 56,
      'yPos': 31
    },
    {
      'name': 'C O2 Canister',
      'nameID': 'CO2CanisterItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 14,
      'yPos': 13
    },
    {
      'name': 'Camas Ash Fertilizer',
      'nameID': 'CamasAshFertilizerItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 10,
      'yPos': 53
    },
    {
      'name': 'Camas Bread',
      'nameID': 'CamasBreadItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 12,
      'yPos': 9
    },
    {
      'name': 'Camas Bulb',
      'nameID': 'CamasBulbItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 2,
      'yPos': 15
    },
    {
      'name': 'Camas Bulb Bake',
      'nameID': 'CamasBulbBakeItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 7,
      'yPos': 10
    },
    {
      'name': 'Camas Paste',
      'nameID': 'CamasPasteItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 25,
      'yPos': 57
    },
    {
      'name': 'Camo Pants',
      'nameID': 'CamoPantsItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 0,
      'yPos': 1,
      'filter': 'invert(15%) sepia(99%) saturate(150%) hue-rotate(83deg) brightness(80%) contrast(180%)'
    },
    {
      'name': 'Camo Shirt',
      'nameID': 'CamoShirtItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 0,
      'yPos': 0,
      'filter': 'invert(15%) sepia(99%) saturate(150%) hue-rotate(83deg) brightness(70%) contrast(180%)'
    },
    {
      'name': 'Campfire',
      'nameID': 'CampfireItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 3,
      'yPos': 11
    },
    {
      'name': 'Campfire Cooking Upgrade',
      'nameID': 'CampfireCookingUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 58,
      'yPos': 31
    },
    {
      'name': 'Campfire Roast',
      'nameID': 'CampfireRoastItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 24,
      'yPos': 54
    },
    {
      'name': 'Campfire Salad',
      'nameID': 'CampfireSaladItem',
      'tag': false
    },
    {
      'name': 'Campfire Salad',
      'nameID': 'CampfireSalad',
      'tag': true,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 8,
      'yPos': 2,
      'filter': 'grayscale(1)'
    },
    {
      'name': 'Campfire Stew',
      'nameID': 'CampfireStewItem',
      'tag': false
    },
    {
      'name': 'Campsite',
      'nameID': 'CampsiteItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 11,
      'yPos': 1
    },
    {
      'name': 'Candle Stand',
      'nameID': 'CandleStandItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 15,
      'yPos': 1
    },
    {
      'name': 'Capitol',
      'nameID': 'CapitolItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 0,
      'yPos': 10
    },
    {
      'name': 'Capris',
      'nameID': 'CaprisItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 1,
      'yPos': 1
    },
    {
      'name': 'Carpentry Advanced Upgrade',
      'nameID': 'CarpentryAdvancedUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 60,
      'yPos': 31
    },
    {
      'name': 'Carpentry Basic Upgrade',
      'nameID': 'CarpentryBasicUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 62,
      'yPos': 31
    },
    {
      'name': 'Carpentry Table',
      'nameID': 'CarpentryTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 15,
      'yPos': 10
    },
    {
      'name': 'Carved Pumpkin',
      'nameID': 'CarvedPumpkinItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 9,
      'yPos': 1
    },
    {
      'name': 'Cast Iron Bed',
      'nameID': 'CastIronBedItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 8,
      'yPos': 6
    },
    {
      'name': 'Cast Iron Royal Bed',
      'nameID': 'CastIronRoyalBedItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 7,
      'yPos': 6
    },
    {
      'name': 'Cast Iron Stove',
      'nameID': 'CastIronStoveItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 11,
      'yPos': 10
    },
    {
      'name': 'Cedar Log',
      'nameID': 'CedarLogItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 14,
      'yPos': 15
    },
    {
      'name': 'Cedar Seed',
      'nameID': 'CedarSeedItem',
      'tag': false
    },
    {
      'name': 'Ceiba Log',
      'nameID': 'CeibaLogItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 14,
      'yPos': 12
    },
    {
      'name': 'Ceiba Seed',
      'nameID': 'CeibaSeedItem',
      'tag': false
    },
    {
      'name': 'Ceiling Candle',
      'nameID': 'CeilingCandleItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 15,
      'yPos': 3
    },
    {
      'name': 'Cellulose Fiber',
      'nameID': 'CelluloseFiberItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 12,
      'yPos': 53
    },
    {
      'name': 'Cement',
      'nameID': 'CementItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 5,
      'yPos': 11
    },
    {
      'name': 'Cement Kiln',
      'nameID': 'CementKilnItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 9,
      'yPos': 10
    },
    {
      'name': 'Census Bureau',
      'nameID': 'CensusBureauItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 1,
      'yPos': 10
    },
    {
      'name': 'Cereal Germ',
      'nameID': 'CerealGermItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 9,
      'yPos': 12
    },
    {
      'name': 'Chainsaw',
      'nameID': 'ChainsawItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 12,
      'yPos': 3
    },
    {
      'name': 'Chair',
      'nameID': 'ChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 13,
      'yPos': 15
    },
    {
      'name': 'Charcoal',
      'nameID': 'CharcoalItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 13,
      'yPos': 11
    },
    {
      'name': 'Charred Agave',
      'nameID': 'CharredAgaveItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 6,
      'yPos': 3
    },
    {
      'name': 'Charred Beans',
      'nameID': 'CharredBeansItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 0,
      'yPos': 3
    },
    {
      'name': 'Charred Beet',
      'nameID': 'CharredBeetItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 14,
      'yPos': 9
    },
    {
      'name': 'Charred Cactus Fruit',
      'nameID': 'CharredCactusFruitItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 2,
      'yPos': 1
    },
    {
      'name': 'Charred Camas Bulb',
      'nameID': 'CharredCamasBulbItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 15,
      'yPos': 9
    },
    {
      'name': 'Charred Corn',
      'nameID': 'CharredCornItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 0,
      'yPos': 10
    },
    {
      'name': 'Charred Fireweed Shoots',
      'nameID': 'CharredFireweedShootsItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 13,
      'yPos': 1
    },
    {
      'name': 'Charred Fish',
      'nameID': 'CharredFishItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 1,
      'yPos': 10
    },
    {
      'name': 'Charred Heart Of Palm',
      'nameID': 'CharredHeartOfPalmItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 1,
      'yPos': 3
    },
    {
      'name': 'Charred Meat',
      'nameID': 'CharredMeatItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 2,
      'yPos': 10
    },
    {
      'name': 'Charred Mushrooms',
      'nameID': 'CharredMushroomsItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 3,
      'yPos': 1
    },
    {
      'name': 'Charred Papaya',
      'nameID': 'CharredPapayaItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 1,
      'yPos': 2
    },
    {
      'name': 'Charred Pineapple',
      'nameID': 'CharredPineappleItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 3,
      'yPos': 10
    },
    {
      'name': 'Charred Sausage',
      'nameID': 'CharredSausageItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 4,
      'yPos': 10
    },
    {
      'name': 'Charred Taro',
      'nameID': 'CharredTaroItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 7,
      'yPos': 2
    },
    {
      'name': 'Charred Tomato',
      'nameID': 'CharredTomatoItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 5,
      'yPos': 10
    },
    {
      'name': 'Chef Hat',
      'nameID': 'ChefHatItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 12,
      'yPos': 1
    },
    {
      'name': 'Chef Pants',
      'nameID': 'ChefPantsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 10,
      'yPos': 1
    },
    {
      'name': 'Chef Shirt',
      'nameID': 'ChefShirtItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 11,
      'yPos': 1
    },
    {
      'name': 'Chef Shoes',
      'nameID': 'ChefShoesItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 13,
      'yPos': 1
    },
    {
      'name': 'Clam',
      'nameID': 'ClamItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 10,
      'yPos': 12
    },
    {
      'name': 'Clam Chowder',
      'nameID': 'ClamChowderItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 12,
      'yPos': 3
    },
    {
      'name': 'Clay',
      'nameID': 'ClayItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 14,
      'yPos': 1
    },
    {
      'name': 'Cloth',
      'nameID': 'ClothItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 5,
      'yPos': 4
    },
    {
      'name': 'Cloth Belt',
      'nameID': 'ClothBeltItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 3,
      'yPos': 7
    },
    {
      'name': 'Cloth Cape',
      'nameID': 'ClothCapeItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 2,
      'yPos': 7
    },
    {
      'name': 'Clothes',
      'nameID': 'Clothes',
      'tag': true
    },
    {
      'name': 'Coal',
      'nameID': 'CoalItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 5,
      'yPos': 7
    },
    {
      'name': 'Coal',
      'nameID': 'Coal',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 11,
      'yPos': 4
    },
    {
      'name': 'Cod',
      'nameID': 'CodItem',
      'tag': false
    },
    {
      'name': 'Combustion Engine',
      'nameID': 'CombustionEngineItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 9,
      'yPos': 7
    },
    {
      'name': 'Combustion Generator',
      'nameID': 'CombustionGeneratorItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 12,
      'yPos': 3
    },
    {
      'name': 'Composite Birch Bench',
      'nameID': 'CompositeBirchBenchItem',
      'tag': false
    },
    {
      'name': 'Composite Birch Chair',
      'nameID': 'CompositeBirchChairItem',
      'tag': false
    },
    {
      'name': 'Composite Birch Door',
      'nameID': 'CompositeBirchDoorItem',
      'tag': false
    },
    {
      'name': 'Composite Birch Lumber',
      'nameID': 'CompositeBirchLumberItem',
      'tag': false
    },
    {
      'name': 'Composite Birch Table',
      'nameID': 'CompositeBirchTableItem',
      'tag': false
    },
    {
      'name': 'Composite Bow',
      'nameID': 'CompositeBowItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 0,
      'yPos': 14
    },
    {
      'name': 'Composite Cedar Bench',
      'nameID': 'CompositeCedarBenchItem',
      'tag': false
    },
    {
      'name': 'Composite Cedar Chair',
      'nameID': 'CompositeCedarChairItem',
      'tag': false
    },
    {
      'name': 'Composite Cedar Door',
      'nameID': 'CompositeCedarDoorItem',
      'tag': false
    },
    {
      'name': 'Composite Cedar Lumber',
      'nameID': 'CompositeCedarLumberItem',
      'tag': false
    },
    {
      'name': 'Composite Cedar Table',
      'nameID': 'CompositeCedarTableItem',
      'tag': false
    },
    {
      'name': 'Composite Ceiba Bench',
      'nameID': 'CompositeCeibaBenchItem',
      'tag': false
    },
    {
      'name': 'Composite Ceiba Chair',
      'nameID': 'CompositeCeibaChairItem',
      'tag': false
    },
    {
      'name': 'Composite Ceiba Door',
      'nameID': 'CompositeCeibaDoorItem',
      'tag': false
    },
    {
      'name': 'Composite Ceiba Lumber',
      'nameID': 'CompositeCeibaLumberItem',
      'tag': false
    },
    {
      'name': 'Composite Ceiba Table',
      'nameID': 'CompositeCeibaTableItem',
      'tag': false
    },
    {
      'name': 'Composite Filler',
      'nameID': 'CompositeFillerItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 19,
      'yPos': 53
    },
    {
      'name': 'Composite Fir Bench',
      'nameID': 'CompositeFirBenchItem',
      'tag': false
    },
    {
      'name': 'Composite Fir Chair',
      'nameID': 'CompositeFirChairItem',
      'tag': false
    },
    {
      'name': 'Composite Fir Door',
      'nameID': 'CompositeFirDoorItem',
      'tag': false
    },
    {
      'name': 'Composite Fir Lumber',
      'nameID': 'CompositeFirLumberItem',
      'tag': false
    },
    {
      'name': 'Composite Fir Table',
      'nameID': 'CompositeFirTableItem',
      'tag': false
    },
    {
      'name': 'Composite Hardwood Bench',
      'nameID': 'CompositeHardwoodBenchItem',
      'tag': false
    },
    {
      'name': 'Composite Hardwood Chair',
      'nameID': 'CompositeHardwoodChairItem',
      'tag': false
    },
    {
      'name': 'Composite Hardwood Door',
      'nameID': 'CompositeHardwoodDoorItem',
      'tag': false
    },
    {
      'name': 'Composite Hardwood Table',
      'nameID': 'CompositeHardwoodTableItem',
      'tag': false
    },
    {
      'name': 'Composite Joshua Bench',
      'nameID': 'CompositeJoshuaBenchItem',
      'tag': false
    },
    {
      'name': 'Composite Joshua Chair',
      'nameID': 'CompositeJoshuaChairItem',
      'tag': false
    },
    {
      'name': 'Composite Joshua Door',
      'nameID': 'CompositeJoshuaDoorItem',
      'tag': false
    },
    {
      'name': 'Composite Joshua Lumber',
      'nameID': 'CompositeJoshuaLumberItem',
      'tag': false
    },
    {
      'name': 'Composite Joshua Table',
      'nameID': 'CompositeJoshuaTableItem',
      'tag': false
    },
    {
      'name': 'Composite Lumber',
      'nameID': 'CompositeLumberItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 10,
      'yPos': 14
    },
    {
      'name': 'Composite Lumber Bench',
      'nameID': 'CompositeLumberBenchItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 14,
      'yPos': 15
    },
    {
      'name': 'Composite Lumber Chair',
      'nameID': 'CompositeLumberChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 13,
      'yPos': 15
    },
    {
      'name': 'Composite Lumber Door',
      'nameID': 'CompositeLumberDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 10,
      'yPos': 15
    },
    {
      'name': 'Composite Lumber Table',
      'nameID': 'CompositeLumberTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 15,
      'yPos': 15
    },
    {
      'name': 'Composite Oak Bench',
      'nameID': 'CompositeOakBenchItem',
      'tag': false
    },
    {
      'name': 'Composite Oak Chair',
      'nameID': 'CompositeOakChairItem',
      'tag': false
    },
    {
      'name': 'Composite Oak Door',
      'nameID': 'CompositeOakDoorItem',
      'tag': false
    },
    {
      'name': 'Composite Oak Lumber',
      'nameID': 'CompositeOakLumberItem',
      'tag': false
    },
    {
      'name': 'Composite Oak Table',
      'nameID': 'CompositeOakTableItem',
      'tag': false
    },
    {
      'name': 'Composite Palm Bench',
      'nameID': 'CompositePalmBenchItem',
      'tag': false
    },
    {
      'name': 'Composite Palm Chair',
      'nameID': 'CompositePalmChairItem',
      'tag': false
    },
    {
      'name': 'Composite Palm Door',
      'nameID': 'CompositePalmDoorItem',
      'tag': false
    },
    {
      'name': 'Composite Palm Lumber',
      'nameID': 'CompositePalmLumberItem',
      'tag': false
    },
    {
      'name': 'Composite Palm Table',
      'nameID': 'CompositePalmTableItem',
      'tag': false
    },
    {
      'name': 'Composite Redwood Bench',
      'nameID': 'CompositeRedwoodBenchItem',
      'tag': false
    },
    {
      'name': 'Composite Redwood Chair',
      'nameID': 'CompositeRedwoodChairItem',
      'tag': false
    },
    {
      'name': 'Composite Redwood Door',
      'nameID': 'CompositeRedwoodDoorItem',
      'tag': false
    },
    {
      'name': 'Composite Redwood Lumber',
      'nameID': 'CompositeRedwoodLumberItem',
      'tag': false
    },
    {
      'name': 'Composite Redwood Table',
      'nameID': 'CompositeRedwoodTableItem',
      'tag': false
    },
    {
      'name': 'Composite Saguaro Bench',
      'nameID': 'CompositeSaguaroBenchItem',
      'tag': false
    },
    {
      'name': 'Composite Saguaro Chair',
      'nameID': 'CompositeSaguaroChairItem',
      'tag': false
    },
    {
      'name': 'Composite Saguaro Door',
      'nameID': 'CompositeSaguaroDoorItem',
      'tag': false
    },
    {
      'name': 'Composite Saguaro Lumber',
      'nameID': 'CompositeSaguaroLumberItem',
      'tag': false
    },
    {
      'name': 'Composite Saguaro Table',
      'nameID': 'CompositeSaguaroTableItem',
      'tag': false
    },
    {
      'name': 'Composite Softwood Bench',
      'nameID': 'CompositeSoftwoodBenchItem',
      'tag': false
    },
    {
      'name': 'Composite Softwood Chair',
      'nameID': 'CompositeSoftwoodChairItem',
      'tag': false
    },
    {
      'name': 'Composite Softwood Door',
      'nameID': 'CompositeSoftwoodDoorItem',
      'tag': false
    },
    {
      'name': 'Composite Softwood Table',
      'nameID': 'CompositeSoftwoodTableItem',
      'tag': false
    },
    {
      'name': 'Composite Spruce Bench',
      'nameID': 'CompositeSpruceBenchItem',
      'tag': false
    },
    {
      'name': 'Composite Spruce Chair',
      'nameID': 'CompositeSpruceChairItem',
      'tag': false
    },
    {
      'name': 'Composite Spruce Door',
      'nameID': 'CompositeSpruceDoorItem',
      'tag': false
    },
    {
      'name': 'Composite Spruce Lumber',
      'nameID': 'CompositeSpruceLumberItem',
      'tag': false
    },
    {
      'name': 'Composite Spruce Table',
      'nameID': 'CompositeSpruceTableItem',
      'tag': false
    },
    {
      'name': 'Composite Lumber',
      'nameID': 'CompositeLumber',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 5,
      'yPos': 2
    },
    {
      'name': 'Composites Upgrade',
      'nameID': 'CompositesUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 0,
      'yPos': 30
    },
    {
      'name': 'Compost',
      'nameID': 'CompostItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 2,
      'yPos': 5
    },
    {
      'name': 'Compost Fertilizer',
      'nameID': 'CompostFertilizerItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 22,
      'yPos': 53
    },
    {
      'name': 'Computer Lab',
      'nameID': 'ComputerLabItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 6,
      'yPos': 3
    },
    {
      'name': 'Concrete',
      'nameID': 'Concrete',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 11,
      'yPos': 2
    },
    {
      'name': 'Construction Post',
      'nameID': 'ConstructionPostItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 8,
      'yPos': 12
    },
    {
      'name': 'Contract Board',
      'nameID': 'ContractBoardItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 4,
      'yPos': 9
    },
    {
      'name': 'Cookeina Mushroom Spores',
      'nameID': 'CookeinaMushroomSporesItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 17,
      'yPos': 55
    },
    {
      'name': 'Cookeina Mushrooms',
      'nameID': 'CookeinaMushroomsItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 6,
      'yPos': 1
    },
    {
      'name': 'Cooking Upgrade',
      'nameID': 'CookingUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 2,
      'yPos': 30
    },
    {
      'name': 'Copper Bar',
      'nameID': 'CopperBarItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 12,
      'yPos': 7
    },
    {
      'name': 'Copper Concentrate',
      'nameID': 'CopperConcentrateItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 10,
      'yPos': 9
    },
    {
      'name': 'Copper Ore',
      'nameID': 'CopperOreItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 11,
      'yPos': 0
    },
    {
      'name': 'Copper Pipe',
      'nameID': 'CopperPipeItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 1,
      'yPos': 4,
      'filter': 'invert(33%) sepia(40%) saturate(275%) hue-rotate(344deg) brightness(80%) contrast(250%)'
    },
    {
      'name': 'Copper Wiring',
      'nameID': 'CopperWiringItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 9,
      'yPos': 6
    },
    {
      'name': 'Corn',
      'nameID': 'CornItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 9,
      'yPos': 4
    },
    {
      'name': 'Corn Fritters',
      'nameID': 'CornFrittersItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 6,
      'yPos': 9
    },
    {
      'name': 'Corn Seed',
      'nameID': 'CornSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 42,
      'yPos': 57
    },
    {
      'name': 'Corn Starch',
      'nameID': 'CornStarchItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 6,
      'yPos': 12
    },
    {
      'name': 'Cornmeal',
      'nameID': 'CornmealItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 40,
      'yPos': 57
    },
    {
      'name': 'Corrugated Steel',
      'nameID': 'CorrugatedSteelItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 5,
      'yPos': 10
    },
    {
      'name': 'Corrugated Steel Door',
      'nameID': 'CorrugatedSteelDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 10,
      'yPos': 15
    },
    {
      'name': 'Corrugated Steel Fence Door',
      'nameID': 'CorrugatedSteelFenceDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 10,
      'yPos': 15
    },
    {
      'name': 'Cotton Boll',
      'nameID': 'CottonBollItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 3,
      'yPos': 12
    },
    {
      'name': 'Cotton Carpet',
      'nameID': 'CottonCarpetItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 12,
      'yPos': 13
    },
    {
      'name': 'Cotton Curtains',
      'nameID': 'CottonCurtainsItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 1,
      'yPos': 14
    },
    {
      'name': 'Cotton Fabric',
      'nameID': 'CottonFabricItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 5,
      'yPos': 12
    },
    {
      'name': 'Cotton Seed',
      'nameID': 'CottonSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 1,
      'yPos': 13
    },
    {
      'name': 'Cotton Thread',
      'nameID': 'CottonThreadItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 8,
      'yPos': 13
    },
    {
      'name': 'Couch',
      'nameID': 'CouchItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 10,
      'yPos': 9
    },
    {
      'name': 'Court',
      'nameID': 'CourtItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 3,
      'yPos': 10
    },
    {
      'name': 'Coyote Carcass',
      'nameID': 'CoyoteCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 2,
      'yPos': 3
    },
    {
      'name': 'Crab Carcass',
      'nameID': 'CrabCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 4,
      'yPos': 3
    },
    {
      'name': 'Crab Pot',
      'nameID': 'CrabPotItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 8,
      'yPos': 9
    },
    {
      'name': 'Crafting Table',
      'nameID': 'Crafting Table',
      'tag': true
    },
    {
      'name': 'Crane',
      'nameID': 'CraneItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 7,
      'yPos': 5
    },
    {
      'name': 'Creosote Bush Seed',
      'nameID': 'CreosoteBushSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 6,
      'yPos': 15
    },
    {
      'name': 'Crimini Mushroom Spores',
      'nameID': 'CriminiMushroomSporesItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 48,
      'yPos': 57
    },
    {
      'name': 'Crimini Mushrooms',
      'nameID': 'CriminiMushroomsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 14,
      'yPos': 8
    },
    {
      'name': 'Crimson Salad',
      'nameID': 'CrimsonSaladItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 7,
      'yPos': 9
    },
    {
      'name': 'Crispy Bacon',
      'nameID': 'CrispyBaconItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 51,
      'yPos': 57
    },
    {
      'name': 'Crop',
      'nameID': 'Crop',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 15,
      'yPos': 2
    },
    {
      'name': 'Crop Seed',
      'nameID': 'CropSeed',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 9,
      'yPos': 0
    },
    {
      'name': 'Crushed Basalt',
      'nameID': 'CrushedBasaltItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 15,
      'yPos': 9
    },
    {
      'name': 'Crushed Coal',
      'nameID': 'CrushedCoalItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 11,
      'yPos': 14
    },
    {
      'name': 'Crushed Copper Ore',
      'nameID': 'CrushedCopperOreItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 13,
      'yPos': 9
    },
    {
      'name': 'Crushed Gneiss',
      'nameID': 'CrushedGneissItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 7,
      'yPos': 9
    },
    {
      'name': 'Crushed Gold Ore',
      'nameID': 'CrushedGoldOreItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 12,
      'yPos': 9
    },
    {
      'name': 'Crushed Granite',
      'nameID': 'CrushedGraniteItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 4,
      'yPos': 9
    },
    {
      'name': 'Crushed Iron Ore',
      'nameID': 'CrushedIronOreItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 14,
      'yPos': 9
    },
    {
      'name': 'Crushed Limestone',
      'nameID': 'CrushedLimestoneItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 5,
      'yPos': 9
    },
    {
      'name': 'Crushed Mixed Rock',
      'nameID': 'CrushedMixedRockItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 12,
      'yPos': 10
    },
    {
      'name': 'Crushed Oil Shale',
      'nameID': 'CrushedOilShaleItem',
      'tag': false
    },
    {
      'name': 'Crushed Rock',
      'nameID': 'CrushedRock',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 1,
      'yPos': 2
    },
    {
      'name': 'Crushed Sandstone',
      'nameID': 'CrushedSandstoneItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 6,
      'yPos': 9
    },
    {
      'name': 'Crushed Shale',
      'nameID': 'CrushedShaleItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 8,
      'yPos': 9
    },
    {
      'name': 'Crushed Slag',
      'nameID': 'CrushedSlagItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 5,
      'yPos': 4
    },
    {
      'name': 'Crushed Stone',
      'nameID': 'CrushedStoneItem',
      'tag': false
    },
    {
      'name': 'Culinary Research Paper Advanced',
      'nameID': 'CulinaryResearchPaperAdvancedItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 7,
      'yPos': 5
    },
    {
      'name': 'Culinary Research Paper Basic',
      'nameID': 'CulinaryResearchPaperBasicItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 8,
      'yPos': 13
    },
    {
      'name': 'Culinary Research Paper Modern',
      'nameID': 'CulinaryResearchPaperModernItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 8,
      'yPos': 5
    },
    {
      'name': 'Currency Exchange',
      'nameID': 'CurrencyExchangeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 21,
      'yPos': 47
    },
    {
      'name': 'Cutting Edge Cooking Upgrade',
      'nameID': 'CuttingEdgeCookingUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 4,
      'yPos': 30
    },
    {
      'name': 'Deer Carcass',
      'nameID': 'DeerCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 2,
      'yPos': 8
    },
    {
      'name': 'Dendrology Research Paper Advanced',
      'nameID': 'DendrologyResearchPaperAdvancedItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 3,
      'yPos': 5
    },
    {
      'name': 'Dendrology Research Paper Basic',
      'nameID': 'DendrologyResearchPaperBasicItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 10,
      'yPos': 13
    },
    {
      'name': 'Dendrology Research Paper Modern',
      'nameID': 'DendrologyResearchPaperModernItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 4,
      'yPos': 5
    },
    {
      'name': 'Derpy Hat',
      'nameID': 'DerpyHatItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 0,
      'yPos': 4
    },
    {
      'name': 'Dirt',
      'nameID': 'DirtItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 7,
      'yPos': 14
    },
    {
      'name': 'Dirt Ramp',
      'nameID': 'DirtRampItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 14,
      'yPos': 7
    },
    {
      'name': 'Distribution Station',
      'nameID': 'DistributionStationItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 12,
      'yPos': 1
    },
    {
      'name': 'Door',
      'nameID': 'DoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 10,
      'yPos': 15
    },
    {
      'name': 'Dumpster Compost',
      'nameID': 'DumpsterCompostItem',
      'tag': false
    },
    {
      'name': 'Dumpster Garbage',
      'nameID': 'DumpsterGarbageItem',
      'tag': false
    },
    {
      'name': 'Dumpster Recycle',
      'nameID': 'DumpsterRecycleItem',
      'tag': false
    },
    {
      'name': 'Dwarf Willow Seed',
      'nameID': 'DwarfWillowSeedItem',
      'tag': false
    },
    {
      'name': 'Easel',
      'nameID': 'EaselItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 1,
      'yPos': 12
    },
    {
      'name': 'Ecko Statue',
      'nameID': 'EckoStatueItem',
      'tag': false
    },
    {
      'name': 'Ecko The Dolphin',
      'nameID': 'EckoTheDolphinItem',
      'tag': false
    },
    {
      'name': 'Ecoylent',
      'nameID': 'EcoylentItem',
      'tag': false
    },
    {
      'name': 'Electric Lathe',
      'nameID': 'ElectricLatheItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 14,
      'yPos': 1
    },
    {
      'name': 'Electric Machinist Table',
      'nameID': 'ElectricMachinistTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 15,
      'yPos': 2
    },
    {
      'name': 'Electric Motor',
      'nameID': 'ElectricMotorItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 0,
      'yPos': 7
    },
    {
      'name': 'Electric Planer',
      'nameID': 'ElectricPlanerItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 15,
      'yPos': 1
    },
    {
      'name': 'Electric Stamping Press',
      'nameID': 'ElectricStampingPressItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 13,
      'yPos': 1
    },
    {
      'name': 'Electric Wall Lamp',
      'nameID': 'ElectricWallLampItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 10,
      'yPos': 1
    },
    {
      'name': 'Electric Water Pump',
      'nameID': 'ElectricWaterPumpItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 2,
      'yPos': 4
    },
    {
      'name': 'Electronics Assembly',
      'nameID': 'ElectronicsAssemblyItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 10,
      'yPos': 6
    },
    {
      'name': 'Electronics Upgrade',
      'nameID': 'ElectronicsUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 6,
      'yPos': 30
    },
    {
      'name': 'Elevator Call Post',
      'nameID': 'ElevatorCallPostItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 4,
      'yPos': 9
    },
    {
      'name': 'Elk Carcass',
      'nameID': 'ElkCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 0,
      'yPos': 8
    },
    {
      'name': 'Elk Mount',
      'nameID': 'ElkMountItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 9,
      'yPos': 14
    },
    {
      'name': 'Elk Skypiercer',
      'nameID': 'ElkSkypiercerItem',
      'tag': false
    },
    {
      'name': 'Elk Taco',
      'nameID': 'ElkTacoItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 8,
      'yPos': 9
    },
    {
      'name': 'Elk Wellington',
      'nameID': 'ElkWellingtonItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 8,
      'yPos': 10
    },
    {
      'name': 'Engineering Research Paper Advanced',
      'nameID': 'EngineeringResearchPaperAdvancedItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 1,
      'yPos': 5
    },
    {
      'name': 'Engineering Research Paper Modern',
      'nameID': 'EngineeringResearchPaperModernItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 2,
      'yPos': 5
    },
    {
      'name': 'Epoxy',
      'nameID': 'EpoxyItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 10,
      'yPos': 6
    },
    {
      'name': 'Ethanol',
      'nameID': 'EthanolItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 11,
      'yPos': 11
    },
    {
      'name': 'Excavator',
      'nameID': 'ExcavatorItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 2,
      'yPos': 9
    },
    {
      'name': 'Executive Office',
      'nameID': 'ExecutiveOfficeItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 13,
      'yPos': 13
    },
    {
      'name': 'Explorer Belt',
      'nameID': 'ExplorerBeltItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 9,
      'yPos': 1
    },
    {
      'name': 'Explorer Boots',
      'nameID': 'ExplorerBootsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 7,
      'yPos': 1
    },
    {
      'name': 'Explorer Gloves',
      'nameID': 'ExplorerGlovesItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 8,
      'yPos': 1
    },
    {
      'name': 'Explorer Hat',
      'nameID': 'ExplorerHatItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 6,
      'yPos': 1
    },
    {
      'name': 'Explorer Pants',
      'nameID': 'ExplorerPantsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 4,
      'yPos': 1
    },
    {
      'name': 'Explorer Shirt',
      'nameID': 'ExplorerShirtItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 5,
      'yPos': 1
    },
    {
      'name': 'Fabric',
      'nameID': 'Fabric',
      'tag': true,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 5,
      'yPos': 12
    },
    {
      'name': 'Fantastic Forest Pizza',
      'nameID': 'FantasticForestPizzaItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 5,
      'yPos': 3
    },
    {
      'name': 'Farmer Boots',
      'nameID': 'FarmerBootsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 13,
      'yPos': 0
    },
    {
      'name': 'Farmer Gloves',
      'nameID': 'FarmerGlovesItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 14,
      'yPos': 0
    },
    {
      'name': 'Farmer Hat',
      'nameID': 'FarmerHatItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 12,
      'yPos': 0
    },
    {
      'name': 'Farmer Overalls',
      'nameID': 'FarmerOverallsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 10,
      'yPos': 0
    },
    {
      'name': 'Farmer Shirt',
      'nameID': 'FarmerShirtItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 11,
      'yPos': 0
    },
    {
      'name': 'Farmers Table',
      'nameID': 'FarmersTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 7,
      'yPos': 9
    },
    {
      'name': 'Farming Upgrade',
      'nameID': 'FarmingUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 8,
      'yPos': 30
    },
    {
      'name': 'Fat',
      'nameID': 'Fat',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 0,
      'yPos': 4
    },
    {
      'name': 'Fern Campfire Salad',
      'nameID': 'FernCampfireSaladItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 5,
      'yPos': 54
    },
    {
      'name': 'Fern Spore',
      'nameID': 'FernSporeItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 4,
      'yPos': 6
    },
    {
      'name': 'Fertilizer',
      'nameID': 'Fertilizer',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 15,
      'yPos': 7
    },
    {
      'name': 'Fertilizer Filler',
      'nameID': 'FertilizerFiller',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 2,
      'yPos': 8
    },
    {
      'name': 'Fertilizers Upgrade',
      'nameID': 'FertilizersUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 10,
      'yPos': 30
    },
    {
      'name': 'Fiber Filler',
      'nameID': 'FiberFillerItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 32,
      'yPos': 53
    },
    {
      'name': 'Fiberglass',
      'nameID': 'FiberglassItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 3,
      'yPos': 10
    },
    {
      'name': 'Fiddleheads',
      'nameID': 'FiddleheadsItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 10,
      'yPos': 8
    },
    {
      'name': 'Field Campfire Stew',
      'nameID': 'FieldCampfireStewItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 9,
      'yPos': 1
    },
    {
      'name': 'Filmy Fern Spore',
      'nameID': 'FilmyFernSporeItem',
      'tag': false
    },
    {
      'name': 'Fir Log',
      'nameID': 'FirLogItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 14,
      'yPos': 13
    },
    {
      'name': 'Fir Seed',
      'nameID': 'FirSeedItem',
      'tag': false
    },
    {
      'name': 'Fireweed Seed',
      'nameID': 'FireweedSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 58,
      'yPos': 57
    },
    {
      'name': 'Fireweed Shoots',
      'nameID': 'FireweedShootsItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 60,
      'yPos': 57
    },
    {
      'name': 'Fish',
      'nameID': 'Fish',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 6,
      'yPos': 6
    },
    {
      'name': 'Fish N Chips',
      'nameID': 'FishNChipsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 2,
      'yPos': 4
    },
    {
      'name': 'Fish Trap',
      'nameID': 'FishTrapItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 15,
      'yPos': 12
    },
    {
      'name': 'Fishery',
      'nameID': 'FisheryItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 0,
      'yPos': 12
    },
    {
      'name': 'Flat Steel',
      'nameID': 'FlatSteelItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 6,
      'yPos': 10
    },
    {
      'name': 'Flat Steel Door',
      'nameID': 'FlatSteelDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 10,
      'yPos': 15
    },
    {
      'name': 'Flatbread',
      'nameID': 'FlatbreadItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 11,
      'yPos': 10
    },
    {
      'name': 'Flour',
      'nameID': 'FlourItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 4,
      'yPos': 15
    },
    {
      'name': 'Food',
      'nameID': 'Food',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 8,
      'yPos': 0
    },
    {
      'name': 'Fox Carcass',
      'nameID': 'FoxCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 4,
      'yPos': 8
    },
    {
      'name': 'Framed Glass',
      'nameID': 'FramedGlassItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 7,
      'yPos': 10
    },
    {
      'name': 'Framed Glass Door',
      'nameID': 'FramedGlassDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 10,
      'yPos': 15
    },
    {
      'name': 'Fried Camas',
      'nameID': 'FriedCamasItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 4,
      'yPos': 1
    },
    {
      'name': 'Fried Fiddleheads',
      'nameID': 'FriedFiddleheadsItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 15,
      'yPos': 1
    },
    {
      'name': 'Fried Hare Haunches',
      'nameID': 'FriedHareHaunchesItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 15,
      'yPos': 8
    },
    {
      'name': 'Fried Hearts Of Palm',
      'nameID': 'FriedHeartsOfPalmItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 9,
      'yPos': 2
    },
    {
      'name': 'Fried Taro',
      'nameID': 'FriedTaroItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 3,
      'yPos': 3
    },
    {
      'name': 'Fried Tomatoes',
      'nameID': 'FriedTomatoesItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 5,
      'yPos': 11
    },
    {
      'name': 'Fried Vegetable',
      'nameID': 'FriedVegetable',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 5,
      'yPos': 7
    },
    {
      'name': 'Fried Vegetables',
      'nameID': 'FriedVegetablesItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 5,
      'yPos': 1
    },
    {
      'name': 'Froth Floatation Cell',
      'nameID': 'FrothFloatationCellItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 10,
      'yPos': 8
    },
    {
      'name': 'Fruit',
      'nameID': 'Fruit',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 14,
      'yPos': 3
    },
    {
      'name': 'Fruit Muffin',
      'nameID': 'FruitMuffinItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 0,
      'yPos': 2
    },
    {
      'name': 'Fruit Salad',
      'nameID': 'FruitSaladItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 14,
      'yPos': 8
    },
    {
      'name': 'Fruit Tart',
      'nameID': 'FruitTartItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 10,
      'yPos': 2
    },
    {
      'name': 'Fuel',
      'nameID': 'Fuel',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 7,
      'yPos': 1
    },
    {
      'name': 'Fungus',
      'nameID': 'Fungus',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 0,
      'yPos': 3
    },
    {
      'name': 'Fur Pelt',
      'nameID': 'FurPeltItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 9,
      'yPos': 1
    },
    {
      'name': 'Garden Boots',
      'nameID': 'GardenBootsItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 4,
      'yPos': 5
    },
    {
      'name': 'Gasoline',
      'nameID': 'GasolineItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 15,
      'yPos': 13
    },
    {
      'name': 'Gathering Research Paper Basic',
      'nameID': 'GatheringResearchPaperBasicItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 9,
      'yPos': 13
    },
    {
      'name': 'Gearbox',
      'nameID': 'GearboxItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 7,
      'yPos': 7
    },
    {
      'name': 'Geology Research Paper Advanced',
      'nameID': 'GeologyResearchPaperAdvancedItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 15,
      'yPos': 4
    },
    {
      'name': 'Geology Research Paper Basic',
      'nameID': 'GeologyResearchPaperBasicItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 12,
      'yPos': 13
    },
    {
      'name': 'Geology Research Paper Modern',
      'nameID': 'GeologyResearchPaperModernItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 0,
      'yPos': 5
    },
    {
      'name': 'Giant Cactus Fruit',
      'nameID': 'GiantCactusFruitItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 11,
      'yPos': 7
    },
    {
      'name': 'Gigot Sleeve Shirt',
      'nameID': 'GigotSleeveShirtItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 3,
      'yPos': 0
    },
    {
      'name': 'Glass',
      'nameID': 'GlassItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 15,
      'yPos': 11
    },
    {
      'name': 'Glassworking Advanced Upgrade',
      'nameID': 'GlassworkingAdvancedUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 12,
      'yPos': 30
    },
    {
      'name': 'Glassworking Modern Upgrade',
      'nameID': 'GlassworkingModernUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 14,
      'yPos': 30
    },
    {
      'name': 'Glassworks',
      'nameID': 'GlassworksItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 8,
      'yPos': 15
    },
    {
      'name': 'Gneiss',
      'nameID': 'GneissItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 9,
      'yPos': 6
    },
    {
      'name': 'Goat Mount',
      'nameID': 'GoatMountItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 7,
      'yPos': 14
    },
    {
      'name': 'Gold Bar',
      'nameID': 'GoldBarItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 11,
      'yPos': 7
    },
    {
      'name': 'Gold Concentrate',
      'nameID': 'GoldConcentrateItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 9,
      'yPos': 9
    },
    {
      'name': 'Gold Flakes',
      'nameID': 'GoldFlakesItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 13,
      'yPos': 6
    },
    {
      'name': 'Gold Ore',
      'nameID': 'GoldOreItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 5,
      'yPos': 0
    },
    {
      'name': 'Gold Wiring',
      'nameID': 'GoldWiringItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 2,
      'yPos': 15
    },
    {
      'name': 'Government Office',
      'nameID': 'GovernmentOfficeItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 12,
      'yPos': 10
    },
    {
      'name': 'Grain',
      'nameID': 'Grain',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 1,
      'yPos': 4
    },
    {
      'name': 'Granite',
      'nameID': 'GraniteItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 10,
      'yPos': 0
    },
    {
      'name': 'Grass Seed',
      'nameID': 'GrassSeedItem',
      'tag': false
    },
    {
      'name': 'Greens',
      'nameID': 'Greens',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 9,
      'yPos': 3
    },
    {
      'name': 'Hand Plow',
      'nameID': 'HandPlowItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 11,
      'yPos': 3
    },
    {
      'name': 'Hanging Long Steel Sign',
      'nameID': 'HangingLongSteelSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 14,
      'yPos': 11
    },
    {
      'name': 'Hanging Steel Framed Sign',
      'nameID': 'HangingSteelFramedSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 12,
      'yPos': 11
    },
    {
      'name': 'Hanging Steel Mine Sign',
      'nameID': 'HangingSteelMineSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 9,
      'yPos': 11
    },
    {
      'name': 'Hanging Steel Plain Sign',
      'nameID': 'HangingSteelPlainSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 8,
      'yPos': 11
    },
    {
      'name': 'Hanging Steel Shop Sign',
      'nameID': 'HangingSteelShopSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 10,
      'yPos': 11
    },
    {
      'name': 'Hardwood',
      'nameID': 'Hardwood',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 9,
      'yPos': 1
    },
    {
      'name': 'Hardy Beard',
      'nameID': 'HardyBeardItem',
      'tag': false
    },
    {
      'name': 'Hare Carcass',
      'nameID': 'HareCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 3,
      'yPos': 8
    },
    {
      'name': 'Heart Of Palm',
      'nameID': 'HeartOfPalmItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 13,
      'yPos': 2
    },
    {
      'name': 'Hearty Hometown Pizza',
      'nameID': 'HeartyHometownPizzaItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 4,
      'yPos': 3
    },
    {
      'name': 'Heat Sink',
      'nameID': 'HeatSinkItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 42,
      'yPos': 53
    },
    {
      'name': 'Heliconia Seed',
      'nameID': 'HeliconiaSeedItem',
      'tag': false
    },
    {
      'name': 'Henley',
      'nameID': 'HenleyItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 2,
      'yPos': 0
    },
    {
      'name': 'Hewn Bench',
      'nameID': 'HewnBenchItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 6,
      'yPos': 11
    },
    {
      'name': 'Hewn Chair',
      'nameID': 'HewnChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 8,
      'yPos': 11
    },
    {
      'name': 'Hewn Door',
      'nameID': 'HewnDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 10,
      'yPos': 15
    },
    {
      'name': 'Hewn Dresser',
      'nameID': 'HewnDresserItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 12,
      'yPos': 5
    },
    {
      'name': 'Hewn Log',
      'nameID': 'HewnLogItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 12,
      'yPos': 0
    },
    {
      'name': 'Hewn Log',
      'nameID': 'HewnLog',
      'tag': true,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 12,
      'yPos': 0
    },
    {
      'name': 'Hewn Nightstand',
      'nameID': 'HewnNightstandItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 14,
      'yPos': 5
    },
    {
      'name': 'Hewn Table',
      'nameID': 'HewnTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 7,
      'yPos': 11
    },
    {
      'name': 'Hide Ash Fertilizer',
      'nameID': 'HideAshFertilizerItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 44,
      'yPos': 53
    },
    {
      'name': 'Hosomaki',
      'nameID': 'HosomakiItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 6,
      'yPos': 3
    },
    {
      'name': 'Housing',
      'nameID': 'Housing',
      'tag': true
    },
    {
      'name': 'Huckleberries',
      'nameID': 'HuckleberriesItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 0,
      'yPos': 15
    },
    {
      'name': 'Huckleberry Extract',
      'nameID': 'HuckleberryExtractItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 8,
      'yPos': 56
    },
    {
      'name': 'Huckleberry Fritter',
      'nameID': 'HuckleberryFritterItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 15,
      'yPos': 3
    },
    {
      'name': 'Huckleberry Pie',
      'nameID': 'HuckleberryPieItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 13,
      'yPos': 5
    },
    {
      'name': 'Huckleberry Seed',
      'nameID': 'HuckleberrySeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 11,
      'yPos': 56
    },
    {
      'name': 'Hydrocolloids',
      'nameID': 'HydrocolloidsItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 13,
      'yPos': 56
    },
    {
      'name': 'Icebox',
      'nameID': 'IceboxItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 9,
      'yPos': 9
    },
    {
      'name': 'Industrial Elevator',
      'nameID': 'IndustrialElevatorItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 13,
      'yPos': 10
    },
    {
      'name': 'Industrial Refrigerator',
      'nameID': 'IndustrialRefrigeratorItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 10,
      'yPos': 12
    },
    {
      'name': 'Industry Upgrade',
      'nameID': 'IndustryUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 16,
      'yPos': 30
    },
    {
      'name': 'Infused Oil',
      'nameID': 'InfusedOilItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 15,
      'yPos': 56
    },
    {
      'name': 'Injection Mold Machine',
      'nameID': 'InjectionMoldMachineItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 14,
      'yPos': 12
    },
    {
      'name': 'Iron Axe',
      'nameID': 'IronAxeItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 9,
      'yPos': 10
    },
    {
      'name': 'Iron Axle',
      'nameID': 'IronAxleItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 11,
      'yPos': 6,
      'filter': 'brightness(0.5)'
    },
    {
      'name': 'Iron Bar',
      'nameID': 'IronBarItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 15,
      'yPos': 7
    },
    {
      'name': 'Iron Concentrate',
      'nameID': 'IronConcentrateItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 0,
      'yPos': 8
    },
    {
      'name': 'Iron Gear',
      'nameID': 'IronGearItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 6,
      'yPos': 7,
      'filter': 'brightness(0.5)'
    },
    {
      'name': 'Iron Hammer',
      'nameID': 'IronHammerItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 10,
      'yPos': 10
    },
    {
      'name': 'Iron Hoe',
      'nameID': 'IronHoeItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 11,
      'yPos': 10
    },
    {
      'name': 'Iron Machete',
      'nameID': 'IronMacheteItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 3,
      'yPos': 11
    },
    {
      'name': 'Iron Ore',
      'nameID': 'IronOreItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 7,
      'yPos': 0
    },
    {
      'name': 'Iron Pickaxe',
      'nameID': 'IronPickaxeItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 7,
      'yPos': 10
    },
    {
      'name': 'Iron Pipe',
      'nameID': 'IronPipeItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 1,
      'yPos': 4,
      'filter': 'brightness(0.5)'
    },
    {
      'name': 'Piston',
      'nameID': 'PistonItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 11,
      'yPos': 7
    },
    {
      'name': 'Iron Plate',
      'nameID': 'IronPlateItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 12,
      'yPos': 6,
      'filter': 'brightness(0.5)'
    },
    {
      'name': 'Iron Rock Drill',
      'nameID': 'IronRockDrillItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 11,
      'yPos': 6
    },
    {
      'name': 'Iron Saw Blade',
      'nameID': 'IronSawBladeItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 4,
      'yPos': 14
    },
    {
      'name': 'Iron Shovel',
      'nameID': 'IronShovelItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 6,
      'yPos': 10
    },
    {
      'name': 'Iron Sickle',
      'nameID': 'IronSickleItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 8,
      'yPos': 10
    },
    {
      'name': 'Iron Wheel',
      'nameID': 'IronWheelItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 11,
      'yPos': 7,
      'filter': 'brightness(0.5)'
    },
    {
      'name': 'Jaguar Carcass',
      'nameID': 'JaguarCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 6,
      'yPos': 5
    },
    {
      'name': 'Jaw Crusher',
      'nameID': 'JawCrusherItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 7,
      'yPos': 8
    },
    {
      'name': 'Jointfir Seed',
      'nameID': 'JointfirSeedItem',
      'tag': false
    },
    {
      'name': 'Joshua Log',
      'nameID': 'JoshuaLogItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 12,
      'yPos': 13
    },
    {
      'name': 'Joshua Seed',
      'nameID': 'JoshuaSeedItem',
      'tag': false
    },
    {
      'name': 'Jungle Campfire Salad',
      'nameID': 'JungleCampfireSaladItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 6,
      'yPos': 1
    },
    {
      'name': 'Jungle Campfire Stew',
      'nameID': 'JungleCampfireStewItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 14,
      'yPos': 7
    },
    {
      'name': 'Kelp',
      'nameID': 'KelpItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 13,
      'yPos': 12
    },
    {
      'name': 'Kelp Seed',
      'nameID': 'KelpSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 17,
      'yPos': 56
    },
    {
      'name': 'Kelpy Crab Roll',
      'nameID': 'KelpyCrabRollItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 7,
      'yPos': 3
    },
    {
      'name': 'Kiln',
      'nameID': 'KilnItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 4,
      'yPos': 10
    },
    {
      'name': 'King Fern Spore',
      'nameID': 'KingFernSporeItem',
      'tag': false
    },
    {
      'name': 'Kitchen',
      'nameID': 'KitchenItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 15,
      'yPos': 9
    },
    {
      'name': 'Laboratory',
      'nameID': 'LaboratoryItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 5,
      'yPos': 10
    },
    {
      'name': 'Land Claim Stake',
      'nameID': 'LandClaimStakeItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 5,
      'yPos': 6
    },
    {
      'name': 'Large Bath Mat',
      'nameID': 'LargeBathMatItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 6,
      'yPos': 8
    },
    {
      'name': 'Large Corrugated Steel Door',
      'nameID': 'LargeCorrugatedSteelDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 6,
      'yPos': 4
    },
    {
      'name': 'Large Fish',
      'nameID': 'LargeFish',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 6,
      'yPos': 6
    },
    {
      'name': 'Large Hanging Ashlar Basalt Sign',
      'nameID': 'LargeHangingAshlarBasaltSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Ashlar Gneiss Sign',
      'nameID': 'LargeHangingAshlarGneissSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Ashlar Granite Sign',
      'nameID': 'LargeHangingAshlarGraniteSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Ashlar Limestone Sign',
      'nameID': 'LargeHangingAshlarLimestoneSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Ashlar Sandstone Sign',
      'nameID': 'LargeHangingAshlarSandstoneSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Ashlar Shale Sign',
      'nameID': 'LargeHangingAshlarShaleSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Ashlar Stone Sign',
      'nameID': 'LargeHangingAshlarStoneSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 6,
      'yPos': 15
    },
    {
      'name': 'Large Hanging Birch Sign',
      'nameID': 'LargeHangingBirchSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Cedar Sign',
      'nameID': 'LargeHangingCedarSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Ceiba Sign',
      'nameID': 'LargeHangingCeibaSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Fir Sign',
      'nameID': 'LargeHangingFirSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Hardwood Sign',
      'nameID': 'LargeHangingHardwoodSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Joshua Sign',
      'nameID': 'LargeHangingJoshuaSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Lumber Sign',
      'nameID': 'LargeHangingLumberSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 6,
      'yPos': 15
    },
    {
      'name': 'Large Hanging Mortared Granite Sign',
      'nameID': 'LargeHangingMortaredGraniteSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Mortared Limestone Sign',
      'nameID': 'LargeHangingMortaredLimestoneSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Mortared Sandstone Sign',
      'nameID': 'LargeHangingMortaredSandstoneSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Mortared Stone Sign',
      'nameID': 'LargeHangingMortaredStoneSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 6,
      'yPos': 15
    },
    {
      'name': 'Large Hanging Oak Sign',
      'nameID': 'LargeHangingOakSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Palm Sign',
      'nameID': 'LargeHangingPalmSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Redwood Sign',
      'nameID': 'LargeHangingRedwoodSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Saguaro Sign',
      'nameID': 'LargeHangingSaguaroSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Softwood Sign',
      'nameID': 'LargeHangingSoftwoodSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Spruce Sign',
      'nameID': 'LargeHangingSpruceSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Stone Sign',
      'nameID': 'LargeHangingStoneSignItem',
      'tag': false
    },
    {
      'name': 'Large Hanging Wood Sign',
      'nameID': 'LargeHangingWoodSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 9,
      'yPos': 5
    },
    {
      'name': 'Large Lumber Door',
      'nameID': 'LargeLumberDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 5,
      'yPos': 4
    },
    {
      'name': 'Large Lumber Stockpile',
      'nameID': 'LargeLumberStockpileItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 15,
      'yPos': 14
    },
    {
      'name': 'Large Standing Ashlar Basalt Sign',
      'nameID': 'LargeStandingAshlarBasaltSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Ashlar Gneiss Sign',
      'nameID': 'LargeStandingAshlarGneissSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Ashlar Granite Sign',
      'nameID': 'LargeStandingAshlarGraniteSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Ashlar Limestone Sign',
      'nameID': 'LargeStandingAshlarLimestoneSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Ashlar Sandstone Sign',
      'nameID': 'LargeStandingAshlarSandstoneSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Ashlar Shale Sign',
      'nameID': 'LargeStandingAshlarShaleSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Ashlar Stone Sign',
      'nameID': 'LargeStandingAshlarStoneSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 8,
      'yPos': 15
    },
    {
      'name': 'Large Standing Birch Sign',
      'nameID': 'LargeStandingBirchSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Cedar Sign',
      'nameID': 'LargeStandingCedarSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Ceiba Sign',
      'nameID': 'LargeStandingCeibaSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Fir Sign',
      'nameID': 'LargeStandingFirSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Hardwood Sign',
      'nameID': 'LargeStandingHardwoodSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Joshua Sign',
      'nameID': 'LargeStandingJoshuaSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Lumber Sign',
      'nameID': 'LargeStandingLumberSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 8,
      'yPos': 15
    },
    {
      'name': 'Large Standing Mortared Granite Sign',
      'nameID': 'LargeStandingMortaredGraniteSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Mortared Limestone Sign',
      'nameID': 'LargeStandingMortaredLimestoneSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Mortared Sandstone Sign',
      'nameID': 'LargeStandingMortaredSandstoneSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Mortared Stone Sign',
      'nameID': 'LargeStandingMortaredStoneSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 8,
      'yPos': 15
    },
    {
      'name': 'Large Standing Oak Sign',
      'nameID': 'LargeStandingOakSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Palm Sign',
      'nameID': 'LargeStandingPalmSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Redwood Sign',
      'nameID': 'LargeStandingRedwoodSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Saguaro Sign',
      'nameID': 'LargeStandingSaguaroSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Softwood Sign',
      'nameID': 'LargeStandingSoftwoodSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Spruce Sign',
      'nameID': 'LargeStandingSpruceSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Stone Sign',
      'nameID': 'LargeStandingStoneSignItem',
      'tag': false
    },
    {
      'name': 'Large Standing Wood Sign',
      'nameID': 'LargeStandingWoodSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 8,
      'yPos': 5
    },
    {
      'name': 'Large Windowed Lumber Door',
      'nameID': 'LargeWindowedLumberDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 7,
      'yPos': 4
    },
    {
      'name': 'Laser',
      'nameID': 'LaserItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 0,
      'yPos': 11
    },
    {
      'name': 'Lathe',
      'nameID': 'LatheItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 14,
      'yPos': 3
    },
    {
      'name': 'Lattice Mushroom Spores',
      'nameID': 'LatticeMushroomSporesItem',
      'tag': false
    },
    {
      'name': 'Leather Hide',
      'nameID': 'LeatherHideItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 8,
      'yPos': 1
    },
    {
      'name': 'Leavened Dough',
      'nameID': 'LeavenedDoughItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 7,
      'yPos': 1
    },
    {
      'name': 'Light Backpack',
      'nameID': 'LightBackpackItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 5,
      'yPos': 7
    },
    {
      'name': 'Light Bulb',
      'nameID': 'LightBulbItem',
      'tag': false,
      'imageFile': 'lightbulb.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Limestone',
      'nameID': 'LimestoneItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 6,
      'yPos': 0
    },
    {
      'name': 'Limestone Bison Statue',
      'nameID': 'LimestoneBisonStatueItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 5,
      'yPos': 13
    },
    {
      'name': 'Limestone Otter Statue',
      'nameID': 'LimestoneOtterStatueItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 7,
      'yPos': 13
    },
    {
      'name': 'Limestone Owl Statue',
      'nameID': 'LimestoneOwlStatueItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 4,
      'yPos': 13
    },
    {
      'name': 'Limestone Wolf Statue',
      'nameID': 'LimestoneWolfStatueItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 6,
      'yPos': 13
    },
    {
      'name': 'Liquid Nitrogen',
      'nameID': 'LiquidNitrogenItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 19,
      'yPos': 56
    },
    {
      'name': 'Loaded Taro Fries',
      'nameID': 'LoadedTaroFriesItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 1,
      'yPos': 3
    },
    {
      'name': 'Log',
      'nameID': 'LogItem',
      'tag': false
    },
    {
      'name': 'Logging Advanced Upgrade',
      'nameID': 'LoggingAdvancedUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 20,
      'yPos': 30
    },
    {
      'name': 'Logging Basic Upgrade',
      'nameID': 'LoggingBasicUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 18,
      'yPos': 30
    },
    {
      'name': 'Loom',
      'nameID': 'LoomItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 15,
      'yPos': 11
    },
    {
      'name': 'Low Top Shoes',
      'nameID': 'LowTopShoesItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 2,
      'yPos': 5
    },
    {
      'name': 'Lumber',
      'nameID': 'LumberItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 9,
      'yPos': 0
    },
    {
      'name': 'Lumber',
      'nameID': 'Lumber',
      'tag': true,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 9,
      'yPos': 0
    },
    {
      'name': 'Lumber Bench',
      'nameID': 'LumberBenchItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 6,
      'yPos': 12
    },
    {
      'name': 'Lumber Chair',
      'nameID': 'LumberChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 8,
      'yPos': 12
    },
    {
      'name': 'Lumber Door',
      'nameID': 'LumberDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 10,
      'yPos': 15
    },
    {
      'name': 'Lumber Dresser',
      'nameID': 'LumberDresserItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 8,
      'yPos': 8
    },
    {
      'name': 'Lumber Stockpile',
      'nameID': 'LumberStockpileItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 14,
      'yPos': 14
    },
    {
      'name': 'Lumber Table',
      'nameID': 'LumberTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 7,
      'yPos': 12
    },
    {
      'name': 'Lupine Seed',
      'nameID': 'LupineSeedItem',
      'tag': false
    },
    {
      'name': 'Macarons',
      'nameID': 'MacaronsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 9,
      'yPos': 10
    },
    {
      'name': 'Machinist Table',
      'nameID': 'MachinistTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 6,
      'yPos': 9
    },
    {
      'name': 'Mailbox',
      'nameID': 'MailboxItem',
      'tag': false
    },
    {
      'name': 'Maltodextrin',
      'nameID': 'MaltodextrinItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 22,
      'yPos': 56
    },
    {
      'name': 'Masonry Advanced Upgrade',
      'nameID': 'MasonryAdvancedUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 22,
      'yPos': 30
    },
    {
      'name': 'Masonry Basic Upgrade',
      'nameID': 'MasonryBasicUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 24,
      'yPos': 30
    },
    {
      'name': 'Masonry Table',
      'nameID': 'MasonryTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 8,
      'yPos': 10
    },
    {
      'name': 'Meat Pie',
      'nameID': 'MeatPieItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 14,
      'yPos': 5
    },
    {
      'name': 'Meat Stock',
      'nameID': 'MeatStockItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 7,
      'yPos': 8
    },
    {
      'name': 'Meaty Stew',
      'nameID': 'MeatyStewItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 2,
      'yPos': 2
    },
    {
      'name': 'Mechanical Water Pump',
      'nameID': 'MechanicalWaterPumpItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 5,
      'yPos': 4
    },
    {
      'name': 'Mechanics Advanced Upgrade',
      'nameID': 'MechanicsAdvancedUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 26,
      'yPos': 30
    },
    {
      'name': 'Mechanics Modern Upgrade',
      'nameID': 'MechanicsModernUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 28,
      'yPos': 30
    },
    {
      'name': 'Medium Carcass',
      'nameID': 'MediumCarcass',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 6,
      'yPos': 4
    },
    {
      'name': 'Medium Leather Carcass',
      'nameID': 'MediumLeatherCarcass',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 6,
      'yPos': 4
    },
    {
      'name': 'Medium Fish',
      'nameID': 'MediumFish',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 4,
      'yPos': 8
    },
    {
      'name': 'Medium Wooly Carcass',
      'nameID': 'MediumWoolyCarcass',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 6,
      'yPos': 4
    },
    {
      'name': 'Metal',
      'nameID': 'Metal',
      'tag': true
    },
    {
      'name': 'Metallurgy Research Paper Advanced',
      'nameID': 'MetallurgyResearchPaperAdvancedItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 13,
      'yPos': 4
    },
    {
      'name': 'Metallurgy Research Paper Basic',
      'nameID': 'MetallurgyResearchPaperBasicItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 13,
      'yPos': 13
    },
    {
      'name': 'Metallurgy Research Paper Modern',
      'nameID': 'MetallurgyResearchPaperModernItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 14,
      'yPos': 4
    },
    {
      'name': 'Milk',
      'nameID': 'MilkItem',
      'tag': false
    },
    {
      'name': 'Mill',
      'nameID': 'MillItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 0,
      'yPos': 12
    },
    {
      'name': 'Milling Upgrade',
      'nameID': 'MillingUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 30,
      'yPos': 30
    },
    {
      'name': 'Millionaires Salad',
      'nameID': 'MillionairesSaladItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 4,
      'yPos': 4
    },
    {
      'name': 'Mining Advanced Upgrade',
      'nameID': 'MiningAdvancedUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 32,
      'yPos': 30
    },
    {
      'name': 'Mining Basic Upgrade',
      'nameID': 'MiningBasicUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 34,
      'yPos': 30
    },
    {
      'name': 'Mining Modern Upgrade',
      'nameID': 'MiningModernUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 36,
      'yPos': 30
    },
    {
      'name': 'Mint',
      'nameID': 'MintItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 40,
      'yPos': 47
    },
    {
      'name': 'Mochi',
      'nameID': 'MochiItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 6,
      'yPos': 2
    },
    {
      'name': 'Modern Axe',
      'nameID': 'ModernAxeItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 0,
      'yPos': 13
    },
    {
      'name': 'Modern Double Street Light',
      'nameID': 'ModernDoubleStreetLightItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 4,
      'yPos': 15
    },
    {
      'name': 'Modern Hammer',
      'nameID': 'ModernHammerItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 2,
      'yPos': 13
    },
    {
      'name': 'Modern Hoe',
      'nameID': 'ModernHoeItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 3,
      'yPos': 13
    },
    {
      'name': 'Modern Machete',
      'nameID': 'ModernMacheteItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 11,
      'yPos': 12
    },
    {
      'name': 'Modern Pickaxe',
      'nameID': 'ModernPickaxeItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 1,
      'yPos': 13
    },
    {
      'name': 'Modern Research',
      'nameID': 'ModernResearch',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 14,
      'yPos': 7
    },
    {
      'name': 'Modern Rock Drill',
      'nameID': 'ModernRockDrillItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 10,
      'yPos': 6
    },
    {
      'name': 'Modern Scythe',
      'nameID': 'ModernScytheItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 11,
      'yPos': 11
    },
    {
      'name': 'Modern Shovel',
      'nameID': 'ModernShovelItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 4,
      'yPos': 13
    },
    {
      'name': 'Modern Street Light',
      'nameID': 'ModernStreetLightItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 3,
      'yPos': 15
    },
    {
      'name': 'Modern Upgrade 1',
      'nameID': 'ModernUpgradeLvl1Item',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 8,
      'yPos': 0
    },
    {
      'name': 'Modern Upgrade 2',
      'nameID': 'ModernUpgradeLvl2Item',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 9,
      'yPos': 0
    },
    {
      'name': 'Modern Upgrade 3',
      'nameID': 'ModernUpgradeLvl3Item',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 10,
      'yPos': 0
    },
    {
      'name': 'Modern Upgrade 4',
      'nameID': 'ModernUpgradeLvl4Item',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 11,
      'yPos': 0
    },
    {
      'name': 'Moon Jellyfish',
      'nameID': 'MoonJellyfishItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 2,
      'yPos': 7
    },
    {
      'name': 'Mortar',
      'nameID': 'MortarItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 3,
      'yPos': 3
    },
    {
      'name': 'Mortared Basalt',
      'nameID': 'MortaredBasaltItem',
      'tag': false
    },
    {
      'name': 'Mortared Gneiss',
      'nameID': 'MortaredGneissItem',
      'tag': false
    },
    {
      'name': 'Mortared Granite',
      'nameID': 'MortaredGraniteItem',
      'tag': false
    },
    {
      'name': 'Mortared Granite Bench',
      'nameID': 'MortaredGraniteBenchItem',
      'tag': false
    },
    {
      'name': 'Mortared Granite Chair',
      'nameID': 'MortaredGraniteChairItem',
      'tag': false
    },
    {
      'name': 'Mortared Granite Door',
      'nameID': 'MortaredGraniteDoorItem',
      'tag': false
    },
    {
      'name': 'Mortared Granite Fireplace',
      'nameID': 'MortaredGraniteFireplaceItem',
      'tag': false
    },
    {
      'name': 'Mortared Granite Table',
      'nameID': 'MortaredGraniteTableItem',
      'tag': false
    },
    {
      'name': 'Mortared Limestone',
      'nameID': 'MortaredLimestoneItem',
      'tag': false
    },
    {
      'name': 'Mortared Limestone Bench',
      'nameID': 'MortaredLimestoneBenchItem',
      'tag': false
    },
    {
      'name': 'Mortared Limestone Chair',
      'nameID': 'MortaredLimestoneChairItem',
      'tag': false
    },
    {
      'name': 'Mortared Limestone Door',
      'nameID': 'MortaredLimestoneDoorItem',
      'tag': false
    },
    {
      'name': 'Mortared Limestone Fireplace',
      'nameID': 'MortaredLimestoneFireplaceItem',
      'tag': false
    },
    {
      'name': 'Mortared Limestone Table',
      'nameID': 'MortaredLimestoneTableItem',
      'tag': false
    },
    {
      'name': 'Mortared Sandstone',
      'nameID': 'MortaredSandstoneItem',
      'tag': false
    },
    {
      'name': 'Mortared Sandstone Bench',
      'nameID': 'MortaredSandstoneBenchItem',
      'tag': false
    },
    {
      'name': 'Mortared Sandstone Chair',
      'nameID': 'MortaredSandstoneChairItem',
      'tag': false
    },
    {
      'name': 'Mortared Sandstone Door',
      'nameID': 'MortaredSandstoneDoorItem',
      'tag': false
    },
    {
      'name': 'Mortared Sandstone Fireplace',
      'nameID': 'MortaredSandstoneFireplaceItem',
      'tag': false
    },
    {
      'name': 'Mortared Sandstone Table',
      'nameID': 'MortaredSandstoneTableItem',
      'tag': false
    },
    {
      'name': 'Mortared Shale',
      'nameID': 'MortaredShaleItem',
      'tag': false
    },
    {
      'name': 'Mortared Stone',
      'nameID': 'MortaredStoneItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 9,
      'yPos': 13
    },
    {
      'name': 'Mortared Stone',
      'nameID': 'MortaredStone',
      'tag': true,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 9,
      'yPos': 13
    },
    {
      'name': 'Mortared Stone Bench',
      'nameID': 'MortaredStoneBenchItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 14,
      'yPos': 15
    },
    {
      'name': 'Mortared Stone Chair',
      'nameID': 'MortaredStoneChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 13,
      'yPos': 15
    },
    {
      'name': 'Mortared Stone Door',
      'nameID': 'MortaredStoneDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 10,
      'yPos': 15
    },
    {
      'name': 'Mortared Stone Fireplace',
      'nameID': 'MortaredStoneFireplaceItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 5,
      'yPos': 15
    },
    {
      'name': 'Mortared Stone Table',
      'nameID': 'MortaredStoneTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 15,
      'yPos': 15
    },
    {
      'name': 'Mountain Goat Carcass',
      'nameID': 'MountainGoatCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 1,
      'yPos': 8
    },
    {
      'name': 'Nail',
      'nameID': 'NailItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 4,
      'yPos': 14
    },
    {
      'name': 'Natural Fiber',
      'nameID': 'NaturalFiber',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 15,
      'yPos': 5
    },
    {
      'name': 'Normal Hair',
      'nameID': 'NormalHairItem',
      'tag': false
    },
    {
      'name': 'Nuclear Fuel',
      'nameID': 'NuclearFuelItem',
      'tag': false
    },
    {
      'name': 'Nylon',
      'nameID': 'NylonItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 0,
      'yPos': 13
    },
    {
      'name': 'Nylon Carpet',
      'nameID': 'NylonCarpetItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 13,
      'yPos': 13
    },
    {
      'name': 'Nylon Chips',
      'nameID': 'NylonChipsItem',
      'tag': false
    },
    {
      'name': 'Nylon Curtains',
      'nameID': 'NylonCurtainsItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 0,
      'yPos': 14
    },
    {
      'name': 'Nylon Fabric',
      'nameID': 'NylonFabricItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 11,
      'yPos': 14
    },
    {
      'name': 'Nylon Futon Bed',
      'nameID': 'NylonFutonBedItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 3,
      'yPos': 8
    },
    {
      'name': 'Nylon Futon Couch',
      'nameID': 'NylonFutonCouchItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 4,
      'yPos': 8
    },
    {
      'name': 'Nylon Thread',
      'nameID': 'NylonThreadItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 7,
      'yPos': 13
    },
    {
      'name': 'Oak Log',
      'nameID': 'OakLogItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 12,
      'yPos': 11
    },
    {
      'name': 'Ocean Spray Seed',
      'nameID': 'OceanSpraySeedItem',
      'tag': false
    },
    {
      'name': 'Office Mailbox',
      'nameID': 'OfficeMailboxItem',
      'tag': false
    },
    {
      'name': 'Oil',
      'nameID': 'OilItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 6,
      'yPos': 12
    },
    {
      'name': 'Oil',
      'nameID': 'Oil',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 6,
      'yPos': 8
    },
    {
      'name': 'Oil Drilling Upgrade',
      'nameID': 'OilDrillingUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 46,
      'yPos': 30
    },
    {
      'name': 'Oil Refinery',
      'nameID': 'OilRefineryItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 10,
      'yPos': 10
    },
    {
      'name': 'Orchid Seed',
      'nameID': 'OrchidSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 4,
      'yPos': 1
    },
    {
      'name': 'Ore',
      'nameID': 'Ore',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 0,
      'yPos': 2
    },
    {
      'name': 'Otter Carcass',
      'nameID': 'OtterCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 14,
      'yPos': 12
    },
    {
      'name': 'Pacific Sardine',
      'nameID': 'PacificSardineItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 14,
      'yPos': 6
    },
    {
      'name': 'Padded Chair',
      'nameID': 'PaddedChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 11,
      'yPos': 9
    },
    {
      'name': 'Palm Log',
      'nameID': 'PalmLogItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 12,
      'yPos': 12
    },
    {
      'name': 'Palm Seed',
      'nameID': 'PalmSeedItem',
      'tag': false
    },
    {
      'name': 'Papaya',
      'nameID': 'PapayaItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 0,
      'yPos': 2
    },
    {
      'name': 'Papaya Seed',
      'nameID': 'PapayaSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 12,
      'yPos': 1
    },
    {
      'name': 'Paper',
      'nameID': 'PaperItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 1,
      'yPos': 7
    },
    {
      'name': 'Paper Machine',
      'nameID': 'PaperMachineItem',
      'tag': false
    },
    {
      'name': 'Paper Milling Upgrade',
      'nameID': 'PaperMillingUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 48,
      'yPos': 30
    },
    {
      'name': 'Pastry Dough',
      'nameID': 'PastryDoughItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 8,
      'yPos': 1
    },
    {
      'name': 'Peasant Hair',
      'nameID': 'PeasantHairItem',
      'tag': false
    },
    {
      'name': 'Pelt Fertilizer',
      'nameID': 'PeltFertilizerItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 61,
      'yPos': 53
    },
    {
      'name': 'Petroleum',
      'nameID': 'PetroleumItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 7,
      'yPos': 11
    },
    {
      'name': 'Phad Thai',
      'nameID': 'PhadThaiItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 11,
      'yPos': 2
    },
    {
      'name': 'Phosphate Fertilizer',
      'nameID': 'PhosphateFertilizerItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 63,
      'yPos': 53
    },
    {
      'name': 'Pickaxe',
      'nameID': 'PickaxeItem',
      'tag': false
    },
    {
      'name': 'Pineapple',
      'nameID': 'PineappleItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 9,
      'yPos': 2
    },
    {
      'name': 'Pineapple Friend Rice',
      'nameID': 'PineappleFriendRiceItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 0,
      'yPos': 9
    },
    {
      'name': 'Pineapple Seed',
      'nameID': 'PineappleSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 13,
      'yPos': 1
    },
    {
      'name': 'Pirozhok',
      'nameID': 'PirozhokItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 3,
      'yPos': 2
    },
    {
      'name': 'Plant Fibers',
      'nameID': 'PlantFibersItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 12,
      'yPos': 4
    },
    {
      'name': 'Plastic',
      'nameID': 'PlasticItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 2,
      'yPos': 10
    },
    {
      'name': 'Poke Bowl',
      'nameID': 'PokeBowlItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 1,
      'yPos': 4
    },
    {
      'name': 'Portable Steam Engine',
      'nameID': 'PortableSteamEngineItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 0,
      'yPos': 11
    },
    {
      'name': 'Pottery Upgrade',
      'nameID': 'PotteryUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 50,
      'yPos': 30
    },
    {
      'name': 'Power',
      'nameID': 'Power',
      'tag': true
    },
    {
      'name': 'Powered Cart',
      'nameID': 'PoweredCartItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 10,
      'yPos': 3
    },
    {
      'name': 'Powered Storage Silo',
      'nameID': 'PoweredStorageSiloItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 15,
      'yPos': 10
    },
    {
      'name': 'Prairie Dog Carcass',
      'nameID': 'PrairieDogCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 3,
      'yPos': 5
    },
    {
      'name': 'Prepared Meat',
      'nameID': 'PreparedMeatItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 8,
      'yPos': 15
    },
    {
      'name': 'Prickly Pear Fruit',
      'nameID': 'PricklyPearFruitItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 11,
      'yPos': 4
    },
    {
      'name': 'Prickly Pear Seed',
      'nameID': 'PricklyPearSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 31,
      'yPos': 56
    },
    {
      'name': 'Prime Cut',
      'nameID': 'PrimeCutItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 8,
      'yPos': 14
    },
    {
      'name': 'Printing Press',
      'nameID': 'PrintingPressItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 6,
      'yPos': 11
    },
    {
      'name': 'Pulp Filler',
      'nameID': 'PulpFillerItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 9,
      'yPos': 52
    },
    {
      'name': 'Pump Jack',
      'nameID': 'PumpJackItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 2,
      'yPos': 1
    },
    {
      'name': 'Pumpkin',
      'nameID': 'PumpkinItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 9,
      'yPos': 1
    },
    {
      'name': 'Pumpkin Seed',
      'nameID': 'PumpkinSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 3,
      'yPos': 2
    },
    {
      'name': 'Pupusas',
      'nameID': 'PupusasItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 12,
      'yPos': 2
    },
    {
      'name': 'Quicklime',
      'nameID': 'QuicklimeItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 4,
      'yPos': 0
    },
    {
      'name': 'Radiator',
      'nameID': 'RadiatorItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 13,
      'yPos': 10
    },
    {
      'name': 'Raw Bacon',
      'nameID': 'RawBaconItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 4,
      'yPos': 13
    },
    {
      'name': 'Raw Fish',
      'nameID': 'RawFishItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 8,
      'yPos': 11
    },
    {
      'name': 'Raw Food',
      'nameID': 'RawFood',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 14,
      'yPos': 2
    },
    {
      'name': 'Raw Meat',
      'nameID': 'RawMeatItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 8,
      'yPos': 15
    },
    {
      'name': 'Raw Roast',
      'nameID': 'RawRoastItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 1,
      'yPos': 14
    },
    {
      'name': 'Raw Sausage',
      'nameID': 'RawSausageItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 5,
      'yPos': 12
    },
    {
      'name': 'Real Estate Desk',
      'nameID': 'RealEstateDeskItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 14,
      'yPos': 2
    },
    {
      'name': 'Rebar',
      'nameID': 'RebarItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 14,
      'yPos': 11
    },
    {
      'name': 'Recurve Bow',
      'nameID': 'RecurveBowItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 1,
      'yPos': 14
    },
    {
      'name': 'Redwood Log',
      'nameID': 'RedwoodLogItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 14,
      'yPos': 10
    },
    {
      'name': 'Redwood Seed',
      'nameID': 'RedwoodSeedItem',
      'tag': false
    },
    {
      'name': 'Refrigerator',
      'nameID': 'RefrigeratorItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 8,
      'yPos': 9
    },
    {
      'name': 'Registrar',
      'nameID': 'RegistrarItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 7,
      'yPos': 3
    },
    {
      'name': 'Reinforced Concrete',
      'nameID': 'ReinforcedConcreteItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 13,
      'yPos': 11
    },
    {
      'name': 'Research',
      'nameID': 'Research',
      'tag': true
    },
    {
      'name': 'Research Table',
      'nameID': 'ResearchTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 4,
      'yPos': 12
    },
    {
      'name': 'Rice',
      'nameID': 'RiceItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 4,
      'yPos': 11
    },
    {
      'name': 'Rice Flour',
      'nameID': 'RiceFlourItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 1,
      'yPos': 2
    },
    {
      'name': 'Rice Noodles',
      'nameID': 'RiceNoodlesItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 2,
      'yPos': 2
    },
    {
      'name': 'Rivet',
      'nameID': 'RivetItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 11,
      'yPos': 10
    },
    {
      'name': 'Roast Pumpkin',
      'nameID': 'RoastPumpkinItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 6,
      'yPos': 4
    },
    {
      'name': 'Robotic Assembly Line',
      'nameID': 'RoboticAssemblyLineItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 7,
      'yPos': 6
    },
    {
      'name': 'Rock',
      'nameID': 'Rock',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 6,
      'yPos': 1
    },
    {
      'name': 'Rocker Box',
      'nameID': 'RockerBoxItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 8,
      'yPos': 8
    },
    {
      'name': 'Rolling Mill',
      'nameID': 'RollingMillItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 4,
      'yPos': 7
    },
    {
      'name': 'Root Campfire Salad',
      'nameID': 'RootCampfireSaladItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 15,
      'yPos': 2
    },
    {
      'name': 'Root Campfire Stew',
      'nameID': 'RootCampfireStewItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 13,
      'yPos': 7
    },
    {
      'name': 'Round Pot',
      'nameID': 'PlanterPotRoundItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 13,
      'yPos': 10
    },
    {
      'name': 'Rubber Wheel',
      'nameID': 'RubberWheelItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 5,
      'yPos': 10
    },
    {
      'name': 'Rug Large',
      'nameID': 'RugLargeItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 15,
      'yPos': 11
    },
    {
      'name': 'Rug Medium',
      'nameID': 'RugMediumItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 15,
      'yPos': 10
    },
    {
      'name': 'Rug Small',
      'nameID': 'RugSmallItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 14,
      'yPos': 10
    },
    {
      'name': 'Running Shoes',
      'nameID': 'RunningShoesItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 7,
      'yPos': 7
    },
    {
      'name': 'Saguaro Rib',
      'nameID': 'SaguaroRibItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 12,
      'yPos': 14
    },
    {
      'name': 'Saguaro Seed',
      'nameID': 'SaguaroSeedItem',
      'tag': false
    },
    {
      'name': 'Salad',
      'nameID': 'Salad',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 4,
      'yPos': 3
    },
    {
      'name': 'Salmon',
      'nameID': 'SalmonItem',
      'tag': false
    },
    {
      'name': 'Salt Basket',
      'nameID': 'SaltBasketItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 5,
      'yPos': 10
    },
    {
      'name': 'Sand',
      'nameID': 'SandItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 3,
      'yPos': 9
    },
    {
      'name': 'Sandstone',
      'nameID': 'SandstoneItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 8,
      'yPos': 0
    },
    {
      'name': 'Sawmill',
      'nameID': 'SawmillItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 6,
      'yPos': 12
    },
    {
      'name': 'Saxifrage Seed',
      'nameID': 'SaxifrageSeedItem',
      'tag': false
    },
    {
      'name': 'Scrap Meat',
      'nameID': 'ScrapMeatItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 40,
      'yPos': 56
    },
    {
      'name': 'Screening Machine',
      'nameID': 'ScreeningMachineItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 9,
      'yPos': 8
    },
    {
      'name': 'Screw Press',
      'nameID': 'ScrewPressItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 12,
      'yPos': 5
    },
    {
      'name': 'Screws',
      'nameID': 'ScrewsItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 12,
      'yPos': 14
    },
    {
      'name': 'Scruffy Hair',
      'nameID': 'ScruffyHairItem',
      'tag': false
    },
    {
      'name': 'Seagrass Seed',
      'nameID': 'SeagrassSeedItem',
      'tag': false
    },
    {
      'name': 'Seared Meat',
      'nameID': 'SearedMeatItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 8,
      'yPos': 14
    },
    {
      'name': 'Seeded Camas Roll',
      'nameID': 'SeededCamasRollItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 8,
      'yPos': 3
    },
    {
      'name': 'Seeds',
      'nameID': 'Seeds',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 9,
      'yPos': 0
    },
    {
      'name': 'Sensor Based Belt Sorter',
      'nameID': 'SensorBasedBeltSorterItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 11,
      'yPos': 8
    },
    {
      'name': 'Sensuous Sea Pizza',
      'nameID': 'SensuousSeaPizzaItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 3,
      'yPos': 3
    },
    {
      'name': 'Servo',
      'nameID': 'ServoItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 15,
      'yPos': 10
    },
    {
      'name': 'Shale',
      'nameID': 'ShaleItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 1,
      'yPos': 5
    },
    {
      'name': 'Shaper',
      'nameID': 'ShaperItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 15,
      'yPos': 3
    },
    {
      'name': 'Shark Fillet Soup',
      'nameID': 'SharkFilletSoupItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 11,
      'yPos': 3
    },
    {
      'name': 'Sheep Mount',
      'nameID': 'SheepMountItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 6,
      'yPos': 14
    },
    {
      'name': 'Shelf Cabinet',
      'nameID': 'ShelfCabinetItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 12,
      'yPos': 1
    },
    {
      'name': 'Shipping Container Blue',
      'nameID': 'ShippingContainerBlueItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 3,
      'yPos': 11
    },
    {
      'name': 'Shipping Container Green',
      'nameID': 'ShippingContainerGreenItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 4,
      'yPos': 11
    },
    {
      'name': 'Shipping Container Red',
      'nameID': 'ShippingContainerRedItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 5,
      'yPos': 11
    },
    {
      'name': 'Shorn Wool',
      'nameID': 'ShornWoolItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 4,
      'yPos': 12
    },
    {
      'name': 'Short Beard',
      'nameID': 'ShortBeardItem',
      'tag': false
    },
    {
      'name': 'Shorts',
      'nameID': 'ShortsItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 2,
      'yPos': 1
    },
    {
      'name': 'Shovel',
      'nameID': 'ShovelItem',
      'tag': false
    },
    {
      'name': 'Silica',
      'nameID': 'Silica',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 10,
      'yPos': 7
    },
    {
      'name': 'Simmered Meat',
      'nameID': 'SimmeredMeatItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 1,
      'yPos': 9
    },
    {
      'name': 'Simple Syrup',
      'nameID': 'SimpleSyrupItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 15,
      'yPos': 13
    },
    {
      'name': 'Sink',
      'nameID': 'SinkItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 1,
      'yPos': 4
    },
    {
      'name': 'Skid Steer',
      'nameID': 'SkidSteerItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 9,
      'yPos': 3
    },
    {
      'name': 'Skill Scrolls',
      'nameID': 'Skill Scrolls',
      'tag': true,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 14,
      'yPos': 13
    },
    {
      'name': 'Slag',
      'nameID': 'SlagItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 4,
      'yPos': 4
    },
    {
      'name': 'Small Bath Mat',
      'nameID': 'SmallBathMatItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 5,
      'yPos': 8
    },
    {
      'name': 'Small Carcass',
      'nameID': 'SmallCarcass',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 6,
      'yPos': 4
    },
    {
      'name': 'Small Fish',
      'nameID': 'SmallFish',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 3,
      'yPos': 8
    },
    {
      'name': 'Small Hanging Ashlar Basalt Sign',
      'nameID': 'SmallHangingAshlarBasaltSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Ashlar Gneiss Sign',
      'nameID': 'SmallHangingAshlarGneissSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Ashlar Granite Sign',
      'nameID': 'SmallHangingAshlarGraniteSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Ashlar Limestone Sign',
      'nameID': 'SmallHangingAshlarLimestoneSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Ashlar Sandstone Sign',
      'nameID': 'SmallHangingAshlarSandstoneSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Ashlar Shale Sign',
      'nameID': 'SmallHangingAshlarShaleSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Ashlar Stone Sign',
      'nameID': 'SmallHangingAshlarStoneSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 7,
      'yPos': 15
    },
    {
      'name': 'Small Hanging Birch Sign',
      'nameID': 'SmallHangingBirchSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Cedar Sign',
      'nameID': 'SmallHangingCedarSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Ceiba Sign',
      'nameID': 'SmallHangingCeibaSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Fir Sign',
      'nameID': 'SmallHangingFirSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Hardwood Sign',
      'nameID': 'SmallHangingHardwoodSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Joshua Sign',
      'nameID': 'SmallHangingJoshuaSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Lumber Sign',
      'nameID': 'SmallHangingLumberSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 7,
      'yPos': 15
    },
    {
      'name': 'Small Hanging Mortared Granite Sign',
      'nameID': 'SmallHangingMortaredGraniteSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Mortared Limestone Sign',
      'nameID': 'SmallHangingMortaredLimestoneSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Mortared Sandstone Sign',
      'nameID': 'SmallHangingMortaredSandstoneSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Mortared Stone Sign',
      'nameID': 'SmallHangingMortaredStoneSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 7,
      'yPos': 15
    },
    {
      'name': 'Small Hanging Oak Sign',
      'nameID': 'SmallHangingOakSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Palm Sign',
      'nameID': 'SmallHangingPalmSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Redwood Sign',
      'nameID': 'SmallHangingRedwoodSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Saguaro Sign',
      'nameID': 'SmallHangingSaguaroSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Softwood Sign',
      'nameID': 'SmallHangingSoftwoodSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Spruce Sign',
      'nameID': 'SmallHangingSpruceSignItem',
      'tag': false
    },
    {
      'name': 'Small Hanging Stone Sign',
      'nameID': 'SmallHangingStoneSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 7,
      'yPos': 15
    },
    {
      'name': 'Small Hanging Wood Sign',
      'nameID': 'SmallHangingWoodSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 11,
      'yPos': 5
    },
    {
      'name': 'Small Sink',
      'nameID': 'SmallSinkItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 1,
      'yPos': 14
    },
    {
      'name': 'Small Standing Ashlar Basalt Sign',
      'nameID': 'SmallStandingAshlarBasaltSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Ashlar Gneiss Sign',
      'nameID': 'SmallStandingAshlarGneissSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Ashlar Granite Sign',
      'nameID': 'SmallStandingAshlarGraniteSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Ashlar Limestone Sign',
      'nameID': 'SmallStandingAshlarLimestoneSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Ashlar Sandstone Sign',
      'nameID': 'SmallStandingAshlarSandstoneSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Ashlar Shale Sign',
      'nameID': 'SmallStandingAshlarShaleSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Ashlar Stone Sign',
      'nameID': 'SmallStandingAshlarStoneSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 9,
      'yPos': 15
    },
    {
      'name': 'Small Standing Birch Sign',
      'nameID': 'SmallStandingBirchSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Cedar Sign',
      'nameID': 'SmallStandingCedarSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Ceiba Sign',
      'nameID': 'SmallStandingCeibaSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Fir Sign',
      'nameID': 'SmallStandingFirSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Hardwood Sign',
      'nameID': 'SmallStandingHardwoodSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Joshua Sign',
      'nameID': 'SmallStandingJoshuaSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Lumber Sign',
      'nameID': 'SmallStandingLumberSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 9,
      'yPos': 15
    },
    {
      'name': 'Small Standing Mortared Granite Sign',
      'nameID': 'SmallStandingMortaredGraniteSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Mortared Limestone Sign',
      'nameID': 'SmallStandingMortaredLimestoneSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Mortared Sandstone Sign',
      'nameID': 'SmallStandingMortaredSandstoneSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Mortared Stone Sign',
      'nameID': 'SmallStandingMortaredStoneSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 9,
      'yPos': 15
    },
    {
      'name': 'Small Standing Oak Sign',
      'nameID': 'SmallStandingOakSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Palm Sign',
      'nameID': 'SmallStandingPalmSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Redwood Sign',
      'nameID': 'SmallStandingRedwoodSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Saguaro Sign',
      'nameID': 'SmallStandingSaguaroSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Softwood Sign',
      'nameID': 'SmallStandingSoftwoodSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Spruce Sign',
      'nameID': 'SmallStandingSpruceSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Stone Sign',
      'nameID': 'SmallStandingStoneSignItem',
      'tag': false
    },
    {
      'name': 'Small Standing Wood Sign',
      'nameID': 'SmallStandingWoodSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 10,
      'yPos': 5
    },
    {
      'name': 'Small Stockpile',
      'nameID': 'SmallStockpileItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 12,
      'yPos': 13
    },
    {
      'name': 'Small Table',
      'nameID': 'SmallTableItem',
      'tag': false
    },
    {
      'name': 'Small Wood Cart',
      'nameID': 'SmallWoodCartItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 47,
      'yPos': 46
    },
    {
      'name': 'Smelting Upgrade',
      'nameID': 'SmeltingUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 52,
      'yPos': 30
    },
    {
      'name': 'Smith Apron',
      'nameID': 'SmithApronItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Smith Bandana',
      'nameID': 'SmithBandanaItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 3,
      'yPos': 0
    },
    {
      'name': 'Smith Boots',
      'nameID': 'SmithBootsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 4,
      'yPos': 0
    },
    {
      'name': 'Smith Gloves',
      'nameID': 'SmithGlovesItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 5,
      'yPos': 0
    },
    {
      'name': 'Smith Pants',
      'nameID': 'SmithPantsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 1,
      'yPos': 0
    },
    {
      'name': 'Smooth Gut Noodle Roll',
      'nameID': 'SmoothGutNoodleRollItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 10,
      'yPos': 2
    },
    {
      'name': 'Snapping Turtle Carcass',
      'nameID': 'SnappingTurtleCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 1,
      'yPos': 9
    },
    {
      'name': 'Softwood',
      'nameID': 'Softwood',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 11,
      'yPos': 1
    },
    {
      'name': 'Soil Sampler',
      'nameID': 'SoilSamplerItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 10,
      'yPos': 7
    },
    {
      'name': 'Solar Generator',
      'nameID': 'SolarGeneratorItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 6,
      'yPos': 9
    },
    {
      'name': 'Spiky Roll',
      'nameID': 'SpikyRollItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 9,
      'yPos': 3
    },
    {
      'name': 'Spin Melter',
      'nameID': 'SpinMelterItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 3,
      'yPos': 13
    },
    {
      'name': 'Spruce Log',
      'nameID': 'SpruceLogItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 14,
      'yPos': 14
    },
    {
      'name': 'Spruce Seed',
      'nameID': 'SpruceSeedItem',
      'tag': false
    },
    {
      'name': 'Square Belt',
      'nameID': 'SquareBeltItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 1,
      'yPos': 3
    },
    {
      'name': 'Square Pot',
      'nameID': 'PlanterPotSquareItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 12,
      'yPos': 10
    },
    {
      'name': 'Stamp Mill',
      'nameID': 'StampMillItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 6,
      'yPos': 8
    },
    {
      'name': 'Standing Glass Sign',
      'nameID': 'StandingGlassSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 11,
      'yPos': 11
    },
    {
      'name': 'Standing Long Steel Sign',
      'nameID': 'StandingLongSteelSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 13,
      'yPos': 11
    },
    {
      'name': 'Standing Steel Brick Sign',
      'nameID': 'StandingSteelBrickSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 7,
      'yPos': 11
    },
    {
      'name': 'Steam Engine',
      'nameID': 'SteamEngineItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 7,
      'yPos': 7
    },
    {
      'name': 'Steam Tractor',
      'nameID': 'SteamTractorItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 6,
      'yPos': 7
    },
    {
      'name': 'Steam Tractor Harvester',
      'nameID': 'SteamTractorHarvesterItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 11,
      'yPos': 2
    },
    {
      'name': 'Steam Tractor Plow',
      'nameID': 'SteamTractorPlowItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 10,
      'yPos': 2
    },
    {
      'name': 'Steam Tractor Sower',
      'nameID': 'SteamTractorSowerItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 12,
      'yPos': 2
    },
    {
      'name': 'Steam Truck',
      'nameID': 'SteamTruckItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 9,
      'yPos': 7
    },
    {
      'name': 'Steel Abstract Fixture',
      'nameID': 'SteelAbstractFixtureItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 14,
      'yPos': 15
    },
    {
      'name': 'Steel Axe',
      'nameID': 'SteelAxeItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Steel Axle',
      'nameID': 'SteelAxleItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 11,
      'yPos': 6
    },
    {
      'name': 'Steel Bar',
      'nameID': 'SteelBarItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 1,
      'yPos': 9
    },
    {
      'name': 'Steel Ceiling Light',
      'nameID': 'SteelCeilingLightItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 15,
      'yPos': 5
    },
    {
      'name': 'Steel Floor Lamp',
      'nameID': 'SteelFloorLampItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 14,
      'yPos': 5
    },
    {
      'name': 'Steel Gear',
      'nameID': 'SteelGearItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 6,
      'yPos': 7
    },
    {
      'name': 'Steel Gearbox',
      'nameID': 'SteelGearboxItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 7,
      'yPos': 14
    },
    {
      'name': 'Steel Hammer',
      'nameID': 'SteelHammerItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 2,
      'yPos': 0
    },
    {
      'name': 'Steel Hanging Fixture',
      'nameID': 'SteelHangingFixtureItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 15,
      'yPos': 15
    },
    {
      'name': 'Steel Hanging Lamp',
      'nameID': 'SteelHangingLampItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 14,
      'yPos': 1
    },
    {
      'name': 'Steel Hoe',
      'nameID': 'SteelHoeItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 3,
      'yPos': 0
    },
    {
      'name': 'Steel Kitchen Lamp',
      'nameID': 'SteelKitchenLampItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 12,
      'yPos': 15
    },
    {
      'name': 'Steel Machete',
      'nameID': 'SteelMacheteItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 4,
      'yPos': 11
    },
    {
      'name': 'Steel Pickaxe',
      'nameID': 'SteelPickaxeItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 5,
      'yPos': 0
    },
    {
      'name': 'Steel Pipe',
      'nameID': 'SteelPipeItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 1,
      'yPos': 4
    },
    {
      'name': 'Steel Plate',
      'nameID': 'SteelPlateItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 12,
      'yPos': 6
    },
    {
      'name': 'Steel Saw Blade',
      'nameID': 'SteelSawBladeItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 3,
      'yPos': 14
    },
    {
      'name': 'Steel Searchlight',
      'nameID': 'SteelSearchlightItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 2,
      'yPos': 6
    },
    {
      'name': 'Steel Shovel',
      'nameID': 'SteelShovelItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 8,
      'yPos': 0
    },
    {
      'name': 'Steel Sickle',
      'nameID': 'SteelSickleItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 7,
      'yPos': 0
    },
    {
      'name': 'Steel Square Fixture',
      'nameID': 'SteelSquareFixtureItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 13,
      'yPos': 10
    },
    {
      'name': 'Steel Table Lamp',
      'nameID': 'SteelTableLampItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 13,
      'yPos': 5
    },
    {
      'name': 'Stockpile',
      'nameID': 'StockpileItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 12,
      'yPos': 13
    },
    {
      'name': 'Stone',
      'nameID': 'StoneItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 0,
      'yPos': 14
    },
    {
      'name': 'Stone Axe',
      'nameID': 'StoneAxeItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 12,
      'yPos': 4
    },
    {
      'name': 'Stone Brazier',
      'nameID': 'StoneBrazierItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 14,
      'yPos': 3
    },
    {
      'name': 'Stone Door',
      'nameID': 'StoneDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 10,
      'yPos': 15
    },
    {
      'name': 'Stone Hammer',
      'nameID': 'StoneHammerItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 11,
      'yPos': 4
    },
    {
      'name': 'Stone Machete',
      'nameID': 'StoneMacheteItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 2,
      'yPos': 11
    },
    {
      'name': 'Stone Pickaxe',
      'nameID': 'StonePickaxeItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 14,
      'yPos': 3
    },
    {
      'name': 'Stone Ramp',
      'nameID': 'StoneRampItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 14,
      'yPos': 8
    },
    {
      'name': 'Stone Road',
      'nameID': 'StoneRoadItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 15,
      'yPos': 8
    },
    {
      'name': 'Stone Road Tool',
      'nameID': 'StoneRoadToolItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 13,
      'yPos': 4
    },
    {
      'name': 'Stone Sickle',
      'nameID': 'StoneSickleItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 10,
      'yPos': 4
    },
    {
      'name': 'Stone Well',
      'nameID': 'StoneWellItem',
      'tag': false
    },
    {
      'name': 'Stop Sign',
      'nameID': 'StopSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 6,
      'yPos': 1
    },
    {
      'name': 'Storage Chest',
      'nameID': 'StorageChestItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 0,
      'yPos': 13
    },
    {
      'name': 'Storage Silo',
      'nameID': 'StorageSiloItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 14,
      'yPos': 10
    },
    {
      'name': 'Store',
      'nameID': 'StoreItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 2,
      'yPos': 13
    },
    {
      'name': 'Stove',
      'nameID': 'StoveItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 7,
      'yPos': 12
    },
    {
      'name': 'Strange Fuel',
      'nameID': 'StrangeFuelItem',
      'tag': false
    },
    {
      'name': 'Street Sign',
      'nameID': 'StreetSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 5,
      'yPos': 1
    },
    {
      'name': 'Streetlamp',
      'nameID': 'StreetlampItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 14,
      'yPos': 10
    },
    {
      'name': 'Stuffed Alligator',
      'nameID': 'StuffedAlligatorItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 3,
      'yPos': 13
    },
    {
      'name': 'Stuffed Bison',
      'nameID': 'StuffedBisonItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 2,
      'yPos': 13
    },
    {
      'name': 'Stuffed Elk',
      'nameID': 'StuffedElkItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 1,
      'yPos': 13
    },
    {
      'name': 'Stuffed Goat',
      'nameID': 'StuffedGoatItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 15,
      'yPos': 12
    },
    {
      'name': 'Stuffed Jaguar',
      'nameID': 'StuffedJaguarItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 0,
      'yPos': 13
    },
    {
      'name': 'Stuffed Turkey',
      'nameID': 'StuffedTurkeyItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 10,
      'yPos': 10
    },
    {
      'name': 'Stuffed Wolf',
      'nameID': 'StuffedWolfItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 14,
      'yPos': 12
    },
    {
      'name': 'Substrate',
      'nameID': 'SubstrateItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 14,
      'yPos': 0
    },
    {
      'name': 'Sugar',
      'nameID': 'SugarItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 47,
      'yPos': 56
    },
    {
      'name': 'Sugarcane',
      'nameID': 'SugarcaneItem',
      'tag': false
    },
    {
      'name': 'Sun Cheese',
      'nameID': 'SunCheeseItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 5,
      'yPos': 2
    },
    {
      'name': 'Sunflower Seed',
      'nameID': 'SunflowerSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 12,
      'yPos': 3
    },
    {
      'name': 'Sunflower',
      'nameID': 'SunflowerItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 6,
      'yPos': 4
    },
    {
      'name': 'Sweet Salad',
      'nameID': 'SweetSaladItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 2,
      'yPos': 9
    },
    {
      'name': 'Synthetic Rubber',
      'nameID': 'SyntheticRubberItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 4,
      'yPos': 10
    },
    {
      'name': 'Table',
      'nameID': 'TableItem',
      'tag': false
    },
    {
      'name': 'Tailings',
      'nameID': 'TailingsItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 13,
      'yPos': 8
    },
    {
      'name': 'Tailor Bowler Hat',
      'nameID': 'TailorBowlerHatItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 8,
      'yPos': 0
    },
    {
      'name': 'Tailor Pants',
      'nameID': 'TailorPantsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 6,
      'yPos': 0
    },
    {
      'name': 'Tailor Shirt',
      'nameID': 'TailorShirtItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 7,
      'yPos': 0
    },
    {
      'name': 'Tailor Shoes',
      'nameID': 'TailorShoesItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 9,
      'yPos': 0
    },
    {
      'name': 'Tailoring Basic Upgrade',
      'nameID': 'TailoringBasicUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 54,
      'yPos': 30
    },
    {
      'name': 'Tailoring Modern Upgrade',
      'nameID': 'TailoringModernUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 56,
      'yPos': 30
    },
    {
      'name': 'Tailoring Table',
      'nameID': 'TailoringTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 6,
      'yPos': 13
    },
    {
      'name': 'Tall Boots',
      'nameID': 'TallBootsItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 0,
      'yPos': 5
    },
    {
      'name': 'Tallow',
      'nameID': 'TallowItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 7,
      'yPos': 6
    },
    {
      'name': 'Tallow Candle',
      'nameID': 'TallowCandleItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 15,
      'yPos': 8
    },
    {
      'name': 'Tallow Lamp',
      'nameID': 'TallowLampItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 6,
      'yPos': 1
    },
    {
      'name': 'Tallow Wall Lamp',
      'nameID': 'TallowWallLampItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 8,
      'yPos': 1
    },
    {
      'name': 'Taro Fries',
      'nameID': 'TaroFriesItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 0,
      'yPos': 3
    },
    {
      'name': 'Taro Root',
      'nameID': 'TaroRootItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 8,
      'yPos': 2
    },
    {
      'name': 'Taro Seed',
      'nameID': 'TaroSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 5,
      'yPos': 2
    },
    {
      'name': 'Tasty Tropical Pizza',
      'nameID': 'TastyTropicalPizzaItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 2,
      'yPos': 3
    },
    {
      'name': 'Tiny Carcass',
      'nameID': 'TinyCarcass',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 6,
      'yPos': 4
    },
    {
      'name': 'Tiny Fur Carcass',
      'nameID': 'TinyFurCarcass',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 6,
      'yPos': 4
    },
    {
      'name': 'Tiny Leather Carcass',
      'nameID': 'TinyLeatherCarcass',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 6,
      'yPos': 4
    },
    {
      'name': 'Tiny Stockpile',
      'nameID': 'TinyStockpileItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 12,
      'yPos': 13
    },
    {
      'name': 'Toilet',
      'nameID': 'ToiletItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 0,
      'yPos': 14
    },
    {
      'name': 'Tomato',
      'nameID': 'TomatoItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 5,
      'yPos': 11
    },
    {
      'name': 'Tomato Seed',
      'nameID': 'TomatoSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 52,
      'yPos': 56
    },
    {
      'name': 'Tool',
      'nameID': 'Tool',
      'tag': true
    },
    {
      'name': 'Tool Bench',
      'nameID': 'ToolBenchItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 14,
      'yPos': 9
    },
    {
      'name': 'Topped Porridge',
      'nameID': 'ToppedPorridgeItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 4,
      'yPos': 2
    },
    {
      'name': 'Torch',
      'nameID': 'TorchItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 8,
      'yPos': 12
    },
    {
      'name': 'Torch Stand',
      'nameID': 'TorchStandItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 12,
      'yPos': 9
    },
    {
      'name': 'Tortilla',
      'nameID': 'TortillaItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 9,
      'yPos': 9
    },
    {
      'name': 'Towel Rack',
      'nameID': 'TowelRackItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 7,
      'yPos': 8
    },
    {
      'name': 'Transglutaminase',
      'nameID': 'TransglutaminaseItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 55,
      'yPos': 56
    },
    {
      'name': 'Transmission Pole',
      'nameID': 'TransmissionPoleItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 8,
      'yPos': 3
    },
    {
      'name': 'Treasury',
      'nameID': 'TreasuryItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 3,
      'yPos': 12
    },
    {
      'name': 'Tree Debris',
      'nameID': 'TreeDebrisItem',
      'tag': false
    },
    {
      'name': 'Trillium Seed',
      'nameID': 'TrilliumSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 10,
      'yPos': 2
    },
    {
      'name': 'Trousers',
      'nameID': 'TrousersItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 0,
      'yPos': 1
    },
    {
      'name': 'Trout',
      'nameID': 'TroutItem',
      'tag': false
    },
    {
      'name': 'Truck',
      'nameID': 'TruckItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 8,
      'yPos': 7
    },
    {
      'name': 'Tuna',
      'nameID': 'TunaItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 11,
      'yPos': 12
    },
    {
      'name': 'Turkey Carcass',
      'nameID': 'TurkeyCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 3,
      'yPos': 8
    },
    {
      'name': 'Upgrade',
      'nameID': 'Upgrade',
      'tag': true
    },
    {
      'name': 'Upholstered Chair',
      'nameID': 'UpholsteredChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 1,
      'yPos': 8
    },
    {
      'name': 'Upholstered Couch',
      'nameID': 'UpholsteredCouchItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 2,
      'yPos': 8
    },
    {
      'name': 'Urchin',
      'nameID': 'UrchinItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 9,
      'yPos': 11
    },
    {
      'name': 'Valve',
      'nameID': 'ValveItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 11,
      'yPos': 7
    },
    {
      'name': 'Vegetable',
      'nameID': 'Vegetable',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 6,
      'yPos': 3
    },
    {
      'name': 'Vegetable Medley',
      'nameID': 'VegetableMedleyItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 57,
      'yPos': 56
    },
    {
      'name': 'Vegetable Soup',
      'nameID': 'VegetableSoupItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 4,
      'yPos': 9
    },
    {
      'name': 'Vegetable Stock',
      'nameID': 'VegetableStockItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 8,
      'yPos': 8
    },
    {
      'name': 'Vehicles',
      'nameID': 'Vehicles',
      'tag': true
    },
    {
      'name': 'Wainwright Table',
      'nameID': 'WainwrightTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 3,
      'yPos': 10
    },
    {
      'name': 'Wall Candle',
      'nameID': 'WallCandleItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 14,
      'yPos': 1
    },
    {
      'name': 'Washboard',
      'nameID': 'WashboardItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 10,
      'yPos': 10
    },
    {
      'name': 'Washing Machine',
      'nameID': 'WashingMachineItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 13,
      'yPos': 9
    },
    {
      'name': 'Waste Filter',
      'nameID': 'WasteFilterItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 0,
      'yPos': 4
    },
    {
      'name': 'Waterweed Seed',
      'nameID': 'WaterweedSeedItem',
      'tag': false
    },
    {
      'name': 'Waterwheel',
      'nameID': 'WaterwheelItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 8,
      'yPos': 13
    },
    {
      'name': 'Wet Tailings',
      'nameID': 'WetTailingsItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 12,
      'yPos': 8
    },
    {
      'name': 'Wheat',
      'nameID': 'WheatItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 10,
      'yPos': 15
    },
    {
      'name': 'Wheat Seed',
      'nameID': 'WheatSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 62,
      'yPos': 56
    },
    {
      'name': 'Wheelbarrow',
      'nameID': 'WheelbarrowItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 10,
      'yPos': 3
    },
    {
      'name': 'White Bursage Seed',
      'nameID': 'WhiteBursageSeedItem',
      'tag': false
    },
    {
      'name': 'Wild Mix',
      'nameID': 'WildMixItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 10,
      'yPos': 9
    },
    {
      'name': 'Wild Stew',
      'nameID': 'WildStewItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 2,
      'yPos': 6
    },
    {
      'name': 'Wilted Fiddleheads',
      'nameID': 'WiltedFiddleheadsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 6,
      'yPos': 10
    },
    {
      'name': 'Wind Turbine',
      'nameID': 'WindTurbineItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 4,
      'yPos': 8
    },
    {
      'name': 'Windmill',
      'nameID': 'WindmillItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 7,
      'yPos': 13
    },
    {
      'name': 'Wolf Carcass',
      'nameID': 'WolfCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 2,
      'yPos': 8
    },
    {
      'name': 'Wood',
      'nameID': 'Wood',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 8,
      'yPos': 1
    },
    {
      'name': 'Wood Cart',
      'nameID': 'WoodCartItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 11,
      'yPos': 3
    },
    {
      'name': 'Wood Pulp',
      'nameID': 'WoodPulpItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_0.webp',
      'xPos': 38,
      'yPos': 52
    },
    {
      'name': 'Wood Shop Cart',
      'nameID': 'WoodShopCartItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 11,
      'yPos': 8
    },
    {
      'name': 'Wood Sign',
      'nameID': 'WoodSignItem',
      'tag': false
    },
    {
      'name': 'Wooden Bow',
      'nameID': 'WoodenBowItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 1,
      'yPos': 0
    },
    {
      'name': 'Wooden Ceiling Light',
      'nameID': 'WoodenCeilingLightItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 7,
      'yPos': 12
    },
    {
      'name': 'Wooden Elevator',
      'nameID': 'WoodenElevatorItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 5,
      'yPos': 7
    },
    {
      'name': 'Wooden Fabric Bed',
      'nameID': 'WoodenFabricBedItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 1,
      'yPos': 12
    },
    {
      'name': 'Wooden Floor Lamp',
      'nameID': 'WoodenFloorLampItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 5,
      'yPos': 12
    },
    {
      'name': 'Wooden Hoe',
      'nameID': 'WoodenHoeItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 8,
      'yPos': 4
    },
    {
      'name': 'Wooden Kitchen Lamp',
      'nameID': 'WoodenKitchenLampItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 13,
      'yPos': 15
    },
    {
      'name': 'Wooden Latrine',
      'nameID': 'LatrineItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 4,
      'yPos': 10
    },
    {
      'name': 'Wooden Shovel',
      'nameID': 'WoodenShovelItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 7,
      'yPos': 4
    },
    {
      'name': 'Wooden Straw Bed',
      'nameID': 'WoodenStrawBedItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 2,
      'yPos': 12
    },
    {
      'name': 'Wooden Table Lamp',
      'nameID': 'WoodenTableLampItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 4,
      'yPos': 12
    },
    {
      'name': 'Wooden Wheel',
      'nameID': 'WoodenWheelItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 10,
      'yPos': 7
    },
    {
      'name': 'Wool Carpet',
      'nameID': 'WoolCarpetItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 14,
      'yPos': 13
    },
    {
      'name': 'Wool Curtains',
      'nameID': 'WoolCurtainsItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 15,
      'yPos': 13
    },
    {
      'name': 'Wool Fabric',
      'nameID': 'WoolFabricItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 7,
      'yPos': 12
    },
    {
      'name': 'Wool Yarn',
      'nameID': 'WoolYarnItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 9,
      'yPos': 13
    },
    {
      'name': 'Work Backpack',
      'nameID': 'WorkBackpackItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 4,
      'yPos': 7
    },
    {
      'name': 'Work Boots',
      'nameID': 'WorkBootsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 8,
      'yPos': 7
    },
    {
      'name': 'Workbench',
      'nameID': 'WorkbenchItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 12,
      'yPos': 12
    },
    {
      'name': 'Worldly Donut',
      'nameID': 'WorldlyDonutItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 0,
      'yPos': 4
    },
    {
      'name': 'Yeast',
      'nameID': 'YeastItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 14,
      'yPos': 2
    },
    {
      'name': 'Zoning Office',
      'nameID': 'ZoningOfficeItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 2,
      'yPos': 10
    },
    {
      'name': 'Galaxy Vase',
      'nameID': 'GalaxyVaseItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 2,
      'yPos': 15
    },
    {
      'name': 'Orange Vase',
      'nameID': 'OrangeVaseItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 3,
      'yPos': 15
    },
    {
      'name': 'Plant Vase',
      'nameID': 'PlantVaseItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 4,
      'yPos': 15
    },
    {
      'name': 'Purple Vase',
      'nameID': 'PurpleVaseItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 5,
      'yPos': 15
    },
    {
      'name': 'Red Vase',
      'nameID': 'RedVaseItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 6,
      'yPos': 15
    },
    {
      'name': 'Swirl Vase',
      'nameID': 'SwirlVaseItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 7,
      'yPos': 15
    },
    {
      'name': 'Cotton Lint',
      'nameID': 'CottonLintItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 1,
      'yPos': 15
    },
    {
      'name': 'Copper Plate',
      'nameID': 'CopperPlateItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 11,
      'yPos': 0
    },
    {
      'name': 'Spoiled Food',
      'nameID': 'SpoiledFoodItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 15,
      'yPos': 11
    },
    {
      'name': 'Wooden Moorage Post',
      'nameID': 'WoodenMooragePostItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 10,
      'yPos': 15
    },
    {
      'name': 'Steel Moorage Post',
      'nameID': 'SteelMooragePostItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 9,
      'yPos': 15
    },
    {
      'name': 'Outpost Netting',
      'nameID': 'OutpostNettingItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 1,
      'yPos': 14
    },
    {
      'name': 'Linen Yarn',
      'nameID': 'LinenYarnItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 14,
      'yPos': 7
    },
    {
      'name': 'Glass Lens',
      'nameID': 'GlassLensItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 15,
      'yPos': 7
    },
    {
      'name': 'Art Supplies',
      'nameID': 'ArtSuppliesItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 5,
      'yPos': 8
    },
    {
      'name': 'Camera Film',
      'nameID': 'CameraFilmItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 10,
      'yPos': 7
    },
    {
      'name': 'Canvas',
      'nameID': 'CanvasItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 12,
      'yPos': 7
    },
    {
      'name': 'Carbide Helmet Lamp',
      'nameID': 'CarbideHelmetLampItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 6,
      'yPos': 1
    },
    {
      'name': 'Claim Tool',
      'nameID': 'ClaimToolItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 4,
      'yPos': 12
    },
    {
      'name': 'Colored Powder',
      'nameID': 'ColoredPowderItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 1,
      'yPos': 8
    },
    {
      'name': 'Copper Frame Wide',
      'nameID': 'CopperFrameWideItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 11,
      'yPos': 4
    },
    {
      'name': 'Cotton Streamer Stars',
      'nameID': 'CottonStreamerStarsItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 9,
      'yPos': 4
    },
    {
      'name': 'Cotton Streamer Stripes',
      'nameID': 'CottonStreamerStripesItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 2,
      'yPos': 4
    },
    {
      'name': 'Creosote Flower',
      'nameID': 'CreosoteFlowerItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 7,
      'yPos': 8
    },
    {
      'name': 'Decorative Anchor',
      'nameID': 'DecorativeAnchorItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 2,
      'yPos': 6
    },
    {
      'name': 'Decorative Glass Buoy Blue',
      'nameID': 'DecorativeGlassBuoyBlueItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 13,
      'yPos': 5
    },
    {
      'name': 'Decorative Glass Buoy Green',
      'nameID': 'DecorativeGlassBuoyGreenItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 11,
      'yPos': 5
    },
    {
      'name': 'Decorative Glass Buoy Red',
      'nameID': 'DecorativeGlassBuoyRedItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 12,
      'yPos': 5
    },
    {
      'name': 'Decorative Glass Buoy Violet',
      'nameID': 'DecorativeGlassBuoyVioletItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 15,
      'yPos': 5
    },
    {
      'name': 'Decorative Glass Buoy Yellow',
      'nameID': 'DecorativeGlassBuoyYellowItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 14,
      'yPos': 5
    },
    {
      'name': 'Decorative Hanging Buoy',
      'nameID': 'DecorativeHangingBuoyItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 6
    },
    {
      'name': 'Decorative Life Preserver',
      'nameID': 'DecorativeLifePreserverItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 4,
      'yPos': 6
    },
    {
      'name': 'Decorative Ship Wheel',
      'nameID': 'DecorativeShipWheelItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 1,
      'yPos': 6
    },
    {
      'name': 'Fiber Scutching Station',
      'nameID': 'FiberScutchingStationItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 11,
      'yPos': 7
    },
    {
      'name': 'Fish Rack',
      'nameID': 'FishRackItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 3,
      'yPos': 6
    },
    {
      'name': 'Flaxseed Oil',
      'nameID': 'FlaxseedOilItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 2,
      'yPos': 8
    },
    {
      'name': 'Gathering Basic Upgrade',
      'nameID': 'GatheringBasicUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 11,
      'yPos': 8
    },
    {
      'name': 'Gold Frame Wide',
      'nameID': 'GoldFrameWideItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 8,
      'yPos': 5
    },
    {
      'name': 'Handheld Camera',
      'nameID': 'HandheldCameraItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 12,
      'yPos': 15
    },
    {
      'name': 'Hemp Mooring Rope',
      'nameID': 'HempMooringRopeItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 2,
      'yPos': 14
    },
    {
      'name': 'Industrial Barge',
      'nameID': 'IndustrialBargeItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 4,
      'yPos': 13
    },
    {
      'name': 'Industrial Generator',
      'nameID': 'IndustrialGeneratorItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 10,
      'yPos': 8
    },
    {
      'name': 'Iron Anchor',
      'nameID': 'IronAnchorItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 3,
      'yPos': 14
    },
    {
      'name': 'Iron Frame Wide',
      'nameID': 'IronFrameWideItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 6,
      'yPos': 0
    },
    {
      'name': 'Iron Hull Sheet',
      'nameID': 'IronHullSheetItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 4,
      'yPos': 14
    },
    {
      'name': 'Iron Road Tool',
      'nameID': 'IronRoadToolItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 12,
      'yPos': 7
    },
    {
      'name': 'Large Canoe',
      'nameID': 'LargeCanoeItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 2,
      'yPos': 13
    },
    {
      'name': 'Large Cotton Bunting Red',
      'nameID': 'LargeCottonBuntingRedItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 1,
      'yPos': 4
    },
    {
      'name': 'Large Court',
      'nameID': 'LargeCourtItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 7
    },
    {
      'name': 'Large Festive Paper Lantern',
      'nameID': 'LargeFestivePaperLanternItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 5,
      'yPos': 6
    },
    {
      'name': 'Large Metal Ship Frame',
      'nameID': 'LargeMetalShipFrameItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 5,
      'yPos': 14
    },
    {
      'name': 'Large Nylon Bunting Green',
      'nameID': 'LargeNylonBuntingGreenItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 5,
      'yPos': 4
    },
    {
      'name': 'Large Paper Lantern',
      'nameID': 'LargePaperLanternItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 6,
      'yPos': 6
    },
    {
      'name': 'Large Wooden Ship Frame',
      'nameID': 'LargeWoodenShipFrameItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 6,
      'yPos': 14
    },
    {
      'name': 'Lumber Warehouse Shelves',
      'nameID': 'LumberWarehouseShelvesItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Medium Fishing Trawler',
      'nameID': 'MediumFishingTrawlerItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 6,
      'yPos': 13
    },
    {
      'name': 'Medium Metal Ship Frame',
      'nameID': 'MediumMetalShipFrameItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 7,
      'yPos': 14
    },
    {
      'name': 'Medium Shipyard',
      'nameID': 'MediumShipyardItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 10,
      'yPos': 8
    },
    {
      'name': 'Medium Wooden Ship Frame',
      'nameID': 'MediumWoodenShipFrameItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 8,
      'yPos': 14
    },
    {
      'name': 'Metal Keel',
      'nameID': 'MetalKeelItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 9,
      'yPos': 14
    },
    {
      'name': 'Metal Rudder',
      'nameID': 'MetalRudderItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 10,
      'yPos': 14
    },
    {
      'name': 'Nylon Mooring Rope',
      'nameID': 'NylonMooringRopeItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 11,
      'yPos': 14
    },
    {
      'name': 'Nylon Trawler Net',
      'nameID': 'NylonTrawlerNetItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 13,
      'yPos': 8
    },
    {
      'name': 'Oil Head Lamp',
      'nameID': 'OilHeadLampItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 6,
      'yPos': 1
    },
    {
      'name': 'Oil Paint',
      'nameID': 'OilPaintItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 8
    },
    {
      'name': 'Orchid',
      'nameID': 'OrchidItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 8,
      'yPos': 8
    },
    {
      'name': 'Ornate Gold Frame Wide',
      'nameID': 'OrnateGoldFrameWideItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 8,
      'yPos': 5
    },
    {
      'name': 'Ornate Iron Frame Wide',
      'nameID': 'OrnateIronFrameWideItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ornate Wooden Frame Wide',
      'nameID': 'OrnateWoodenFrameWideItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 3,
      'yPos': 0
    },
    {
      'name': 'Paper Streamers',
      'nameID': 'PaperStreamersItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Plastic Buoy',
      'nameID': 'PlasticBuoyItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 10,
      'yPos': 5
    },
    {
      'name': 'Sandals',
      'nameID': 'SandalsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 13,
      'yPos': 1
    },
    {
      'name': 'Shipwright Overalls',
      'nameID': 'ShipwrightOverallsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 15,
      'yPos': 0
    },
    {
      'name': 'Shipwright Advanced Upgrade',
      'nameID': 'ShipwrightAdvancedUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 2,
      'yPos': 7
    },
    {
      'name': 'Shipwright Basic Upgrade',
      'nameID': 'ShipwrightBasicUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 1,
      'yPos': 7
    },
    {
      'name': 'Shipwright Hat',
      'nameID': 'ShipwrightHatItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 1,
      'yPos': 1
    },
    {
      'name': 'Shipwright Sandals',
      'nameID': 'ShipwrightSandalsItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 9,
      'yPos': 0
    },
    {
      'name': 'Shipwright Shirt',
      'nameID': 'ShipwrightShirtItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 0,
      'yPos': 1
    },
    {
      'name': 'Small Canoe',
      'nameID': 'SmallCanoeItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 1,
      'yPos': 13
    },
    {
      'name': 'Small Cotton Bunting Red',
      'nameID': 'SmallCottonBuntingRedItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 13,
      'yPos': 3
    },
    {
      'name': 'Small Court',
      'nameID': 'SmallCourtItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 15,
      'yPos': 6
    },
    {
      'name': 'Small Festive Paper Lantern',
      'nameID': 'SmallFestivePaperLanternItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Nylon Bunting Green',
      'nameID': 'SmallNylonBuntingGreenItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 6,
      'yPos': 4
    },
    {
      'name': 'Small Paper Lantern',
      'nameID': 'SmallPaperLanternItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 7,
      'yPos': 6
    },
    {
      'name': 'Small Paper Machine',
      'nameID': 'SmallPaperMachineItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 9,
      'yPos': 7
    },
    {
      'name': 'Small Shipyard',
      'nameID': 'SmallShipyardItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 11,
      'yPos': 15
    },
    {
      'name': 'Small Wooden Boat',
      'nameID': 'SmallWoodenBoatItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 0,
      'yPos': 13
    },
    {
      'name': 'Small Wooden Ship Frame',
      'nameID': 'SmallWoodenShipFrameItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 12,
      'yPos': 14
    },
    {
      'name': 'Smith Shirt',
      'nameID': 'SmithShirtItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 2,
      'yPos': 0
    },
    {
      'name': 'Steel Buoy',
      'nameID': 'SteelBuoyItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 9,
      'yPos': 5
    },
    {
      'name': 'Steel Liquids Tank',
      'nameID': 'SteelLiquidsTankItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Steel Warehouse Shelves',
      'nameID': 'SteelWarehouseShelvesItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Trillium Flower',
      'nameID': 'TrilliumFlowerItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 9,
      'yPos': 8
    },
    {
      'name': 'Tripod Camera',
      'nameID': 'TripodCameraItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 13,
      'yPos': 15
    },
    {
      'name': 'Wooden Barge',
      'nameID': 'WoodenBargeItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 3,
      'yPos': 13
    },
    {
      'name': 'Wooden Frame Wide',
      'nameID': 'WoodenFrameWideItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 9,
      'yPos': 0
    },
    {
      'name': 'Wooden Hull Planks',
      'nameID': 'WoodenHullPlanksItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 13,
      'yPos': 14
    },
    {
      'name': 'Wooden Keel',
      'nameID': 'WoodenKeelItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 14,
      'yPos': 14
    },
    {
      'name': 'Wooden Liquids Tank',
      'nameID': 'WoodenLiquidsTankItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Wooden Oar',
      'nameID': 'WoodenOarItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 15,
      'yPos': 14
    },
    {
      'name': 'Wooden Rudder',
      'nameID': 'WoodenRudderItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 0,
      'yPos': 15
    },
    {
      'name': 'Wooden Transport Ship',
      'nameID': 'WoodenTransportShipItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 5,
      'yPos': 13
    },
    {
      'name': 'Court Chair',
      'nameID': 'CourtChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 10,
      'yPos': 13
    },
    {
      'name': 'Flax Fiber',
      'nameID': 'FlaxFiberItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 3,
      'yPos': 8
    },
    {
      'name': 'Flax Seed',
      'nameID': 'FlaxSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 4,
      'yPos': 8
    },
    {
      'name': 'Flax Stem',
      'nameID': 'FlaxStemItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 14,
      'yPos': 8
    },
    {
      'name': 'Flax Trawler Net',
      'nameID': 'FlaxTrawlerNetItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 12,
      'yPos': 8
    },
    {
      'name': 'Huge Banner Sign',
      'nameID': 'HugeBannerSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 4,
      'yPos': 15
    },
    {
      'name': 'Huge Iron Banner Sign',
      'nameID': 'HugeIronBannerSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 15,
      'yPos': 14
    },
    {
      'name': 'Huge Iron Sign',
      'nameID': 'HugeIronSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 5,
      'yPos': 15
    },
    {
      'name': 'Huge Steel Banner Sign',
      'nameID': 'HugeSteelBannerSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 0,
      'yPos': 15
    },
    {
      'name': 'Huge Steel Sign',
      'nameID': 'HugeSteelSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 6,
      'yPos': 15
    },
    {
      'name': 'Huge Wooden Banner Sign',
      'nameID': 'HugeWoodenBannerSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 14,
      'yPos': 14
    },
    {
      'name': 'Linen Fabric',
      'nameID': 'LinenFabricItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 13,
      'yPos': 7
    },
    {
      'name': 'Petals',
      'nameID': 'Petals',
      'tag': true,
      'imageFile': 'UI_Icons_Tags.webp',
      'xPos': 5,
      'yPos': 8
    },
    {
      'name': 'Wooden Mold',
      'nameID': 'WoodenMoldItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 4,
      'yPos': 9
    },
    {
      'name': 'Test Object Culture',
      'nameID': 'TestObjectCultureItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Wet Brick',
      'nameID': 'WetBrickItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 3,
      'yPos': 9
    },
    {
      'name': 'Bathroom',
      'nameID': 'BathroomItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Beaver Carcass',
      'nameID': 'BeaverCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Bedroom',
      'nameID': 'BedroomItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Blackboard',
      'nameID': 'BlackboardItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Bycocket',
      'nameID': 'BycocketItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'CO2 Canister',
      'nameID': 'CO2CanisterItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Camera',
      'nameID': 'CameraItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Canning Assembly',
      'nameID': 'CanningAssemblyItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Cast Iron Bench',
      'nameID': 'CastIronBenchItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 5,
      'yPos': 6
    },
    {
      'name': 'Cast Iron Chair',
      'nameID': 'CastIronChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 3,
      'yPos': 6
    },
    {
      'name': 'Cast Iron Table',
      'nameID': 'CastIronTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 4,
      'yPos': 6
    },
    {
      'name': 'Composite Lumber Dresser',
      'nameID': 'CompositeLumberDresserItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Copper Frame Landscape',
      'nameID': 'CopperFrameLandscapeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Copper Frame Portrait',
      'nameID': 'CopperFramePortraitItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Copper Frame Square',
      'nameID': 'CopperFrameSquareItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Copper Frame Tall',
      'nameID': 'CopperFrameTallItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Cornrows',
      'nameID': 'CornrowsItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Country Foundation',
      'nameID': 'CountryFoundationItem',
      'tag': false,
      'imageFile': 'UI_Icons_02.webp',
      'xPos': 0,
      'yPos': 10
    },
    {
      'name': 'Court Table',
      'nameID': 'CourtTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 11,
      'yPos': 13
    },
    {
      'name': 'Culture',
      'nameID': 'CultureItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Curly',
      'nameID': 'CurlyItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Dried Fish',
      'nameID': 'DriedFishItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 14,
      'yPos': 9
    },
    {
      'name': 'Dried Meat',
      'nameID': 'DriedMeatItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 15,
      'yPos': 9
    },
    {
      'name': 'Embassy Desk',
      'nameID': 'EmbassyDeskItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 15,
      'yPos': 13
    },
    {
      'name': 'Federation Foundation',
      'nameID': 'FederationFoundationItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 9,
      'yPos': 13
    },
    {
      'name': 'Feminine Mannequin',
      'nameID': 'FeminineMannequinItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Gold Frame Landscape',
      'nameID': 'GoldFrameLandscapeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Gold Frame Portrait',
      'nameID': 'GoldFramePortraitItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Gold Frame Square',
      'nameID': 'GoldFrameSquareItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Gold Frame Tall',
      'nameID': 'GoldFrameTallItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hardwood Board',
      'nameID': 'HardwoodBoardItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hardwood Hewn Log',
      'nameID': 'HardwoodHewnLogItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hardwood Lumber Bench',
      'nameID': 'HardwoodLumberBenchItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hardwood Lumber Chair',
      'nameID': 'HardwoodLumberChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hardwood Lumber Door',
      'nameID': 'HardwoodLumberDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hardwood Lumber Dresser',
      'nameID': 'HardwoodLumberDresserItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hardwood Lumber',
      'nameID': 'HardwoodLumberItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hardwood Lumber Table',
      'nameID': 'HardwoodLumberTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hewn Hardwood Bench',
      'nameID': 'HewnHardwoodBenchItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hewn Hardwood Chair',
      'nameID': 'HewnHardwoodChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hewn Hardwood Door',
      'nameID': 'HewnHardwoodDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hewn Hardwood Table',
      'nameID': 'HewnHardwoodTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hewn Softwood Bench',
      'nameID': 'HewnSoftwoodBenchItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hewn Softwood Chair',
      'nameID': 'HewnSoftwoodChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hewn Softwood Door',
      'nameID': 'HewnSoftwoodDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hewn Softwood Table',
      'nameID': 'HewnSoftwoodTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hunting Upgrade',
      'nameID': 'HuntingUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Immigration Desk',
      'nameID': 'ImmigrationDeskItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 14,
      'yPos': 13
    },
    {
      'name': 'Industrial',
      'nameID': 'IndustrialItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Iron Frame Landscape',
      'nameID': 'IronFrameLandscapeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Iron Frame Portrait',
      'nameID': 'IronFramePortraitItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Iron Frame Square',
      'nameID': 'IronFrameSquareItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Iron Frame Tall',
      'nameID': 'IronFrameTallItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Kitchenroom',
      'nameID': 'KitchenroomItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Large Cotton Bunting Festive',
      'nameID': 'LargeCottonBuntingFestiveItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Large Cotton Bunting Regal',
      'nameID': 'LargeCottonBuntingRegalItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Large Cotton Bunting Vibrant',
      'nameID': 'LargeCottonBuntingVibrantItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Large Nylon Bunting Purple',
      'nameID': 'LargeNylonBuntingPurpleItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Large Nylon Bunting Yellow',
      'nameID': 'LargeNylonBuntingYellowItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Large Wooden Bookshelf',
      'nameID': 'LargeWoodenBookshelfItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Limestone Podium',
      'nameID': 'LimestonePodiumItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Livingroom',
      'nameID': 'LivingroomItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Marmot Carcass',
      'nameID': 'MarmotCarcassItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Masculine Mannequin',
      'nameID': 'MasculineMannequinItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Muffin Hat',
      'nameID': 'MuffinHatItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ornate Gold Frame Landscape',
      'nameID': 'OrnateGoldFrameLandscapeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ornate Gold Frame Portrait',
      'nameID': 'OrnateGoldFramePortraitItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ornate Gold Frame Square',
      'nameID': 'OrnateGoldFrameSquareItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ornate Gold Frame Tall',
      'nameID': 'OrnateGoldFrameTallItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ornate Iron Frame Landscape',
      'nameID': 'OrnateIronFrameLandscapeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ornate Iron Frame Portrait',
      'nameID': 'OrnateIronFramePortraitItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ornate Iron Frame Square',
      'nameID': 'OrnateIronFrameSquareItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ornate Iron Frame Tall',
      'nameID': 'OrnateIronFrameTallItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ornate Wooden Frame Landscape',
      'nameID': 'OrnateWoodenFrameLandscapeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ornate Wooden Frame Portrait',
      'nameID': 'OrnateWoodenFramePortraitItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ornate Wooden Frame Square',
      'nameID': 'OrnateWoodenFrameSquareItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ornate Wooden Frame Tall',
      'nameID': 'OrnateWoodenFrameTallItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Outpost Table',
      'nameID': 'OutpostTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 0,
      'yPos': 14
    },
    {
      'name': 'Picture Frame',
      'nameID': 'PictureFrameItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Plastic Bench Blue',
      'nameID': 'PlasticBenchBlueItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Plastic Bench Green',
      'nameID': 'PlasticBenchGreenItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Plastic Bench Red',
      'nameID': 'PlasticBenchRedItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Plastic Chair Blue',
      'nameID': 'PlasticChairBlueItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Plastic Chair Green',
      'nameID': 'PlasticChairGreenItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Plastic Chair Red',
      'nameID': 'PlasticChairRedItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Plastic Table Blue',
      'nameID': 'PlasticTableBlueItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Plastic Table Green',
      'nameID': 'PlasticTableGreenItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Plastic Table Red',
      'nameID': 'PlasticTableRedItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ponytail',
      'nameID': 'PonytailItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Pottery Table',
      'nameID': 'PotteryTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 12,
      'yPos': 15
    },
    {
      'name': 'Primitive Canvas Boots',
      'nameID': 'PrimitiveCanvasBootsItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Primitive Canvas Pants',
      'nameID': 'PrimitiveCanvasPantsItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Primitive Canvas Shorts',
      'nameID': 'PrimitiveCanvasShortsItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Primitive Fur Belt',
      'nameID': 'PrimitiveFurBeltItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Primitive Leather Boots',
      'nameID': 'PrimitiveLeatherBootsItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Primitive Leather Pants',
      'nameID': 'PrimitiveLeatherPantsItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Primitive Leather Shirt',
      'nameID': 'PrimitiveLeatherShirtItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Primitive Leather Shorts',
      'nameID': 'PrimitiveLeatherShortsItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Settlement Crafting Table',
      'nameID': 'SettlementCraftingTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 11,
      'yPos': 9
    },
    {
      'name': 'Sleek Short Hair',
      'nameID': 'SleekShortHairItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Cotton Bunting Festive',
      'nameID': 'SmallCottonBuntingFestiveItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Cotton Bunting Regal',
      'nameID': 'SmallCottonBuntingRegalItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Cotton Bunting Vibrant',
      'nameID': 'SmallCottonBuntingVibrantItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Meeting Chair',
      'nameID': 'SmallMeetingChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Meeting Table',
      'nameID': 'SmallMeetingTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Nylon Bunting Purple',
      'nameID': 'SmallNylonBuntingPurpleItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Nylon Bunting Yellow',
      'nameID': 'SmallNylonBuntingYellowItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Softwood Board',
      'nameID': 'SoftwoodBoardItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Softwood Hewn Log',
      'nameID': 'SoftwoodHewnLogItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Softwood Lumber Bench',
      'nameID': 'SoftwoodLumberBenchItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Softwood Lumber Chair',
      'nameID': 'SoftwoodLumberChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Softwood Lumber Door',
      'nameID': 'SoftwoodLumberDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Softwood Lumber Dresser',
      'nameID': 'SoftwoodLumberDresserItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Softwood Lumber',
      'nameID': 'SoftwoodLumberItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Softwood Lumber Table',
      'nameID': 'SoftwoodLumberTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Spinning Jenny',
      'nameID': 'SpinningJennyItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Steel Podium',
      'nameID': 'SteelPodiumItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Steel Row Seating',
      'nameID': 'SteelRowSeatingItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Stenographers Table',
      'nameID': 'StenographersTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 12,
      'yPos': 13
    },
    {
      'name': 'Students Desk T1',
      'nameID': 'StudentsDeskT1Item',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Students Desk T2',
      'nameID': 'StudentsDeskT2Item',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Students Desk T3',
      'nameID': 'StudentsDeskT3Item',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Sun Butter',
      'nameID': 'SunButterItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Sweet Deer Jerky',
      'nameID': 'SweetDeerJerkyItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 13,
      'yPos': 9
    },
    {
      'name': 'Teachers Desk T1',
      'nameID': 'TeachersDeskT1Item',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Teachers Desk T2',
      'nameID': 'TeachersDeskT2Item',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Teachers Desk T3',
      'nameID': 'TeachersDeskT3Item',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'The Bob',
      'nameID': 'TheBobItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Town Foundation',
      'nameID': 'TownFoundationItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 8,
      'yPos': 13
    },
    {
      'name': 'Trailer Truck',
      'nameID': 'TrailerTruckItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Trapper Fur Hat',
      'nameID': 'TrapperFurHatItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Trapper Leather Hat',
      'nameID': 'TrapperLeatherHatItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Tunic',
      'nameID': 'TunicItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Villagers Cowl Lowered',
      'nameID': 'VillagersCowlLoweredItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Villagers Cowl Raised',
      'nameID': 'VillagersCowlRaisedItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Wanderers Hood Lowered',
      'nameID': 'WanderersHoodLoweredItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Wanderers Hood Raised',
      'nameID': 'WanderersHoodRaisedItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Wooden Frame Landscape',
      'nameID': 'WoodenFrameLandscapeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Wooden Frame Portrait',
      'nameID': 'WoodenFramePortraitItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Wooden Frame Square',
      'nameID': 'WoodenFrameSquareItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Wooden Frame Tall',
      'nameID': 'WoodenFrameTallItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Wooden Podium',
      'nameID': 'WoodenPodiumItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Blacksmith Advanced Upgrade',
      'nameID': 'BlacksmithAdvancedUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 2,
      'yPos': 11
    },
    {
      'name': 'Blacksmith Table',
      'nameID': 'BlacksmithTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 9,
      'yPos': 10
    },
    {
      'name': 'Blacksmith Upgrade',
      'nameID': 'BlacksmithUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 1,
      'yPos': 11
    },
    {
      'name': 'Ceramic Mold',
      'nameID': 'CeramicMoldItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 11,
      'yPos': 10
    },
    {
      'name': 'Clay Mold',
      'nameID': 'ClayMoldItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 10,
      'yPos': 10
    },
    {
      'name': 'Digital Work Station',
      'nameID': 'DigitalWorkStationItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Extruder',
      'nameID': 'ExtruderItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Fletching Table',
      'nameID': 'FletchingTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 5,
      'yPos': 11
    },
    {
      'name': 'Gathering Advanced Upgrade',
      'nameID': 'GatheringAdvancedUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 14,
      'yPos': 10
    },
    {
      'name': 'Grindstone',
      'nameID': 'GrindstoneItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 7,
      'yPos': 10
    },
    {
      'name': 'Ink',
      'nameID': 'InkItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 13,
      'yPos': 10
    },
    {
      'name': 'Lighthouse Lamp',
      'nameID': 'LighthouseLampItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 3,
      'yPos': 11
    },
    {
      'name': 'Paint Bucket',
      'nameID': 'PaintBucketItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 12,
      'yPos': 10
    },
    {
      'name': 'Power Hammer',
      'nameID': 'PowerHammerItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 6,
      'yPos': 10
    },
    {
      'name': 'Printing Supplies',
      'nameID': 'PrintingSuppliesItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 11
    },
    {
      'name': 'Smelting Basic Upgrade',
      'nameID': 'SmeltingBasicUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 15,
      'yPos': 10
    },
    {
      'name': 'Tailoring Basic Upgrade',
      'nameID': 'TailoringUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_04.webp',
      'xPos': 6,
      'yPos': 13
    },
    {
      'name': 'Town Bell',
      'nameID': 'TownBellItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 8,
      'yPos': 10
    },
    {
      'name': 'Adobe Door',
      'nameID': 'AdobeDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 2,
      'yPos': 13
    },
    {
      'name': 'Adobe',
      'nameID': 'AdobeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 13,
      'yPos': 12
    },
    {
      'name': 'Baker Sign',
      'nameID': 'BakerSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 9,
      'yPos': 0
    },
    {
      'name': 'Base Paint',
      'nameID': 'BasePaintItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 12,
      'yPos': 10
    },
    {
      'name': 'Bison Pelt',
      'nameID': 'BisonPeltItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Blue Powder',
      'nameID': 'BluePowderItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_1.webp',
      'xPos': 61,
      'yPos': 36
    },
    {
      'name': 'Bonsai',
      'nameID': 'BonsaiItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Carpenter Sign',
      'nameID': 'CarpenterSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 10,
      'yPos': 0
    },
    {
      'name': 'Cart Blueprint Poster',
      'nameID': 'CartBlueprintPosterItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 8,
      'yPos': 0
    },
    {
      'name': 'Cast Iron Plaque',
      'nameID': 'CastIronPlaqueItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 0,
      'yPos': 2
    },
    {
      'name': 'Chandelier',
      'nameID': 'ChandelierItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 3,
      'yPos': 13
    },
    {
      'name': 'Charcoal Powder',
      'nameID': 'CharcoalPowderItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_1.webp',
      'xPos': 0,
      'yPos': 35
    },
    {
      'name': 'Coarse Stone',
      'nameID': 'CoarseStoneItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 5,
      'yPos': 14
    },
    {
      'name': 'Cooking Utensils',
      'nameID': 'CookingUtensilsItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 6,
      'yPos': 14
    },
    {
      'name': 'Copper Hydroxide',
      'nameID': 'CopperHydroxideItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_1.webp',
      'xPos': 2,
      'yPos': 35
    },
    {
      'name': 'Cyan Powder',
      'nameID': 'CyanPowderItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_1.webp',
      'xPos': 4,
      'yPos': 35
    },
    {
      'name': 'Deer Pelt',
      'nameID': 'DeerPeltItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 1,
      'yPos': 0
    },
    {
      'name': 'Dowel',
      'nameID': 'DowelItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 7,
      'yPos': 14
    },
    {
      'name': 'Egyptian Canoe',
      'nameID': 'EgyptianCanoeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 3,
      'yPos': 14
    },
    {
      'name': 'Election Poster',
      'nameID': 'ElectionPosterItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 5,
      'yPos': 0
    },
    {
      'name': 'Engineer Sign',
      'nameID': 'EngineerSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 11,
      'yPos': 0
    },
    {
      'name': 'Fancy Hewn Door',
      'nameID': 'FancyHewnDoorItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 4,
      'yPos': 13
    },
    {
      'name': 'Far East Lumber',
      'nameID': 'FarEastLumberItem',
      'tag': false,
      'imageFile': 'UI_Icons_03.webp',
      'xPos': 9,
      'yPos': 0
    },
    {
      'name': 'Farmer Sign',
      'nameID': 'FarmerSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 12,
      'yPos': 0
    },
    {
      'name': 'FishKite',
      'nameID': 'FishKitesItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 15,
      'yPos': 15
    },
    {
      'name': 'Food Sign',
      'nameID': 'FoodSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 13,
      'yPos': 0
    },
    {
      'name': 'Fox Pelt',
      'nameID': 'FoxPeltItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 2,
      'yPos': 0
    },
    {
      'name': 'Friendly Scarecrow',
      'nameID': 'FriendlyScarecrowItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 4,
      'yPos': 1
    },
    {
      'name': 'Fuse',
      'nameID': 'FuseItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 8,
      'yPos': 14
    },
    {
      'name': 'Garden Gravel',
      'nameID': 'GardenGravelItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 6,
      'yPos': 15
    },
    {
      'name': 'Garden Pond',
      'nameID': 'GardenPondItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 9,
      'yPos': 1
    },
    {
      'name': 'Granite Spiral Fountain',
      'nameID': 'GraniteSpiralFountainItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 5,
      'yPos': 13
    },
    {
      'name': 'Granite Terrace Fountain',
      'nameID': 'GraniteTerraceFountainItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 6,
      'yPos': 13
    },
    {
      'name': 'Hanging Electric Wall Lamp',
      'nameID': 'HangingElectricWallLampItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 7,
      'yPos': 13
    },
    {
      'name': 'Hare Pelt',
      'nameID': 'HarePeltItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 3,
      'yPos': 0
    },
    {
      'name': 'Industrial Mill',
      'nameID': 'IndustrialMillItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 10,
      'yPos': 1
    },
    {
      'name': 'Iron Oxide',
      'nameID': 'IronOxideItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_1.webp',
      'xPos': 6,
      'yPos': 35
    },
    {
      'name': 'Iron Paint Sprayer',
      'nameID': 'IronPaintSprayerItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 6,
      'yPos': 11
    },
    {
      'name': 'Kite',
      'nameID': 'KiteItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 14,
      'yPos': 15
    },
    {
      'name': 'Koi Pond',
      'nameID': 'KoiPondItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 6,
      'yPos': 1
    },
    {
      'name': 'Lubricant',
      'nameID': 'LubricantItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 9,
      'yPos': 14
    },
    {
      'name': 'Magenta Powder',
      'nameID': 'MagentaPowderItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_1.webp',
      'xPos': 8,
      'yPos': 35
    },
    {
      'name': 'Mason Sign',
      'nameID': 'MasonSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 14,
      'yPos': 0
    },
    {
      'name': 'Mill Stone',
      'nameID': 'MillStoneItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 10,
      'yPos': 14
    },
    {
      'name': 'Modern Paint Sprayer',
      'nameID': 'ModernPaintSprayerItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 14,
      'yPos': 12
    },
    {
      'name': 'Norse Canoe',
      'nameID': 'NorseCanoeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 4,
      'yPos': 14
    },
    {
      'name': 'Ornate Cast Iron Plaque',
      'nameID': 'OrnateCastIronPlaqueItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ornate Stone Plaque',
      'nameID': 'OrnateStonePlaqueItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ornate Wood Plaque',
      'nameID': 'OrnateWoodPlaqueItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Paint Mixer',
      'nameID': 'PaintMixerItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 2,
      'yPos': 14
    },
    {
      'name': 'Painting Upgrade',
      'nameID': 'PaintingUpgradeItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 11,
      'yPos': 15
    },
    {
      'name': 'Periodic Table Poster',
      'nameID': 'PeriodicTablePosterItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 7,
      'yPos': 0
    },
    {
      'name': 'Plastic Outdoor Bench',
      'nameID': 'PlasticOutdoorBenchItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 0,
      'yPos': 6
    },
    {
      'name': 'Plastic Outdoor Chair',
      'nameID': 'PlasticOutdoorChairItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 1,
      'yPos': 6
    },
    {
      'name': 'Plastic Outdoor Table',
      'nameID': 'PlasticOutdoorTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 15,
      'yPos': 5
    },
    {
      'name': 'Plastic Window Planter',
      'nameID': 'PlasticWindowPlanterItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 9,
      'yPos': 13
    },
    {
      'name': 'Polishing Paste',
      'nameID': 'PolishingPasteItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 15,
      'yPos': 14
    },
    {
      'name': 'Redwoods Poster',
      'nameID': 'RedwoodsPosterItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 6,
      'yPos': 0
    },
    {
      'name': 'Rustic Window Planter',
      'nameID': 'RusticWindowPlanterItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 10,
      'yPos': 13
    },
    {
      'name': 'Scarecrow',
      'nameID': 'ScarecrowItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 5,
      'yPos': 1
    },
    {
      'name': 'Sharpening Steel',
      'nameID': 'SharpeningSteelItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 1,
      'yPos': 15
    },
    {
      'name': 'Shipwright Sign',
      'nameID': 'ShipwrightSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 15,
      'yPos': 0
    },
    {
      'name': 'Steam Tractor Scoop',
      'nameID': 'SteamTractorScoopItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 11,
      'yPos': 1
    },
    {
      'name': 'Steel Spring',
      'nameID': 'SteelSpringItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 2,
      'yPos': 15
    },
    {
      'name': 'Stone Plaque',
      'nameID': 'StonePlaqueItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 1,
      'yPos': 2
    },
    {
      'name': 'Store Sign',
      'nameID': 'StoreSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 0,
      'yPos': 1
    },
    {
      'name': 'Tailor Sign',
      'nameID': 'TailorSignItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 1,
      'yPos': 1
    },
    {
      'name': 'Tapestry Fish',
      'nameID': 'TapestryFishItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 2,
      'yPos': 1
    },
    {
      'name': 'Tapestry',
      'nameID': 'TapestryItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 13,
      'yPos': 15
    },
    {
      'name': 'Tapestry Sunset',
      'nameID': 'TapestrySunsetItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 3,
      'yPos': 1
    },
    {
      'name': 'Tiki Torch',
      'nameID': 'TikiTorchItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 12,
      'yPos': 13
    },
    {
      'name': 'Wall Mounted Chest',
      'nameID': 'WallMountedChestItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 7,
      'yPos': 1
    },
    {
      'name': 'Wall Mounted Trunk',
      'nameID': 'WallMountedTrunkItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 8,
      'yPos': 1
    },
    {
      'name': 'Whetstone',
      'nameID': 'WhetstoneItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 3,
      'yPos': 15
    },
    {
      'name': 'White Powder',
      'nameID': 'WhitePowderItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_1.webp',
      'xPos': 10,
      'yPos': 35
    },
    {
      'name': 'Window Shutters Center',
      'nameID': 'WindowShuttersCenterItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 13,
      'yPos': 13
    },
    {
      'name': 'Window Shutters Left',
      'nameID': 'WindowShuttersLeftItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 15,
      'yPos': 13
    },
    {
      'name': 'Window Shutters Right',
      'nameID': 'WindowShuttersRightItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 14,
      'yPos': 13
    },
    {
      'name': 'Wolf Pelt',
      'nameID': 'WolfPeltItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 4,
      'yPos': 0
    },
    {
      'name': 'Wood Plaque',
      'nameID': 'WoodPlaqueItem',
      'tag': false,
      'imageFile': 'UI_Icons_07.webp',
      'xPos': 15,
      'yPos': 1
    },
    {
      'name': 'Wood Window Planter',
      'nameID': 'WoodWindowPlanterItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 11,
      'yPos': 13
    },
    {
      'name': 'Wooden Gear',
      'nameID': 'WoodenGearItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 4,
      'yPos': 15
    },
    {
      'name': 'Wooden Paint Sprayer',
      'nameID': 'WoodenPaintSprayerItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 7,
      'yPos': 11
    },
    {
      'name': 'Wooden Wall Torch Stand',
      'nameID': 'WoodenWallTorchStandItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 14
    },
    {
      'name': 'Yellow Powder',
      'nameID': 'YellowPowderItem',
      'tag': false,
      'imageFile': 'UI_Icons_Baked_1.webp',
      'xPos': 12,
      'yPos': 35
    },
    {
      'name': 'Zataku Table',
      'nameID': 'ZatakuTableItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 1,
      'yPos': 14
    },
    {
      'name': 'Zen Garden',
      'nameID': 'ZenGardenItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 5,
      'yPos': 15
    },
    {
      'name': 'Fishing Pole',
      'nameID': 'FishingPoleItem',
      'tag': false,
      'imageFile': 'UI_Icons_01.webp',
      'xPos': 13,
      'yPos': 11
    },
    {
      'name': 'Homestead Claim Stake',
      'nameID': 'HomesteadClaimStakeItem',
      'tag': false,
      'imageFile': 'UI_Icons_05.webp',
      'xPos': 5,
      'yPos': 12
    },
    {
      'name': 'Garbage',
      'nameID': 'GarbageItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 11,
      'yPos': 13
    },
    {
      'name': 'Decorative Bowl',
      'nameID': 'DecorativeBowlItem',
      'tag': false
    },
    {
      'name': 'Fish Kites',
      'nameID': 'FishKitesItem',
      'tag': false
    },
    {
      'name': 'Black Powder',
      'nameID': 'BlackPowderItem',
      'tag': false,
      'imageFile': 'BlackPowder.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Blasting Cap',
      'nameID': 'BlastingCapItem',
      'tag': false,
      'imageFile': 'BlastingCap.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Crushed Sulfur',
      'nameID': 'CrushedSulfurItem',
      'tag': false,
      'imageFile': 'CrushedSulfur_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Dynamite',
      'nameID': 'DynamiteItem',
      'tag': false,
      'imageFile': 'DynamiteObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Mining Charge',
      'nameID': 'MiningChargeItem',
      'tag': false,
      'imageFile': 'MiningChargeObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Nitric Acid',
      'nameID': 'NitricAcidItem',
      'tag': false,
      'imageFile': 'NitricAcid.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Peat',
      'nameID': 'PeatItem',
      'tag': false,
      'imageFile': 'Peat_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Remote Detonator',
      'nameID': 'RemoteDetonatorItem',
      'tag': false,
      'imageFile': 'ModernDetonator_FPV_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Shoji Door',
      'nameID': 'ShojiDoorItem',
      'tag': false
    },
    {
      'name': 'Stump Bed',
      'nameID': 'StumpBedItem',
      'tag': false,
      'imageFile': 'StumpBedObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Stump Chair',
      'nameID': 'StumpChairItem',
      'tag': false,
      'imageFile': 'StumpChairObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Stump Latrine',
      'nameID': 'StumpLatrineItem',
      'tag': false,
      'imageFile': 'StumpLatrineObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Stump Table',
      'nameID': 'StumpTableItem',
      'tag': false,
      'imageFile': 'StumpTableObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Sulfur',
      'nameID': 'SulfurItem',
      'tag': false,
      'imageFile': 'Sulfur_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Wooden Sliding Door',
      'nameID': 'WoodenSlidingDoorItem',
      'tag': false,
      'imageFile': 'WoodenSlidingDoorObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Anatomy Book',
      'nameID': 'AnatomyBookItem',
      'tag': false,
      'imageFile': 'AnatomyBookObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Atlas Book',
      'nameID': 'AtlasBookItem',
      'tag': false,
      'imageFile': 'AtlasBookObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Banana Rug',
      'nameID': 'BananaRugItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Banana Shirt',
      'nameID': 'BananaShirtItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Botanical Book',
      'nameID': 'BotanicalBookItem',
      'tag': false,
      'imageFile': 'BotanicalBookObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ceramic Tea Cup',
      'nameID': 'CeramicTeaCupItem',
      'tag': false,
      'imageFile': 'CeramicTeaCupObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ceramic Tea Pot',
      'nameID': 'CeramicTeaPotItem',
      'tag': false,
      'imageFile': 'CeramicTeapotObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Ceramic Tray',
      'nameID': 'CeramicTrayItem',
      'tag': false,
      'imageFile': 'CeramicTrayObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Coffee Table',
      'nameID': 'CoffeeTableItem',
      'tag': false,
      'imageFile': 'CoffeeTableObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Daisy',
      'nameID': 'DaisyItem',
      'tag': false,
      'imageFile': 'DaisyItem_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Daisy Seed',
      'nameID': 'DaisySeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 6,
      'yPos': 15
    },
    {
      'name': 'Eco Book',
      'nameID': 'EcoBookItem',
      'tag': false,
      'imageFile': 'EcoBookObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Elk Gong',
      'nameID': 'ElkGongItem',
      'tag': false,
      'imageFile': 'ElkGongObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Elk Statuette',
      'nameID': 'ElkStatuetteItem',
      'tag': false,
      'imageFile': 'ElkStatuetteObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Fancy Medium Lumber Store Window',
      'nameID': 'FancyMediumLumberStoreWindowItem',
      'tag': false,
      'imageFile': 'FancyMediumLumberStoreWindowObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Flax Flower',
      'nameID': 'FlaxFlowerItem',
      'tag': false,
      'imageFile': 'FlaxFlowerItem_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Gold Trim Book',
      'nameID': 'GoldTrimBookItem',
      'tag': false,
      'imageFile': 'GoldTrimBookObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hanging Basket',
      'nameID': 'HangingBasketItem',
      'tag': false,
      'imageFile': 'HangingBasketObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hardwood Double Shelf',
      'nameID': 'HardwoodDoubleShelfItem',
      'tag': false,
      'imageFile': 'HardwoodDoubleShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hardwood Lumber Hallway Table',
      'nameID': 'HardwoodLumberHallwayTableItem',
      'tag': false,
      'imageFile': 'HardwoodLumberHallwayTableObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Heated Display Cabinet',
      'nameID': 'HeatedDisplayCabinetItem',
      'tag': false,
      'imageFile': 'HeatedDisplayCabinetObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Hourglass',
      'nameID': 'HourglassItem',
      'tag': false,
      'imageFile': 'HourglassObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Large Glass Store Window',
      'nameID': 'LargeGlassStoreWindowItem',
      'tag': false,
      'imageFile': 'LargeGlassStoreWindowObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Large Lumber Store Window',
      'nameID': 'LargeLumberStoreWindowItem',
      'tag': false,
      'imageFile': 'LargeLumberStoreWindowObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Long Basic Hardwood Shelf',
      'nameID': 'LongBasicHardwoodShelfItem',
      'tag': false,
      'imageFile': 'LongBasicHardwoodShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Long Basic Softwood Shelf',
      'nameID': 'LongBasicSoftwoodShelfItem',
      'tag': false,
      'imageFile': 'LongBasicSoftwoodShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Long Basic Wood Shelf',
      'nameID': 'LongBasicWoodShelfItem',
      'tag': false,
      'imageFile': 'LongBasicWoodShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Long Floating Hardwood Shelf',
      'nameID': 'LongFloatingHardwoodShelfItem',
      'tag': false,
      'imageFile': 'LongFloatingHardwoodShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Long Floating Softwood Shelf',
      'nameID': 'LongFloatingSoftwoodShelfItem',
      'tag': false,
      'imageFile': 'LongFloatingSoftwoodShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Long Floating Wood Shelf',
      'nameID': 'LongFloatingWoodShelfItem',
      'tag': false,
      'imageFile': 'LongFloatingWoodShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Long Hardwood Lumber Shelf',
      'nameID': 'LongHardwoodLumberShelfItem',
      'tag': false,
      'imageFile': 'LongHardwoodLumberShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Long Hardwood Veneer Shelf',
      'nameID': 'LongHardwoodVeneerShelfItem',
      'tag': false,
      'imageFile': 'LongHardwoodVeneerShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Long Lumber Shelf',
      'nameID': 'LongLumberShelfItem',
      'tag': false,
      'imageFile': 'LongLumberShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Long Softwood Lumber Shelf',
      'nameID': 'LongSoftwoodLumberShelfItem',
      'tag': false,
      'imageFile': 'LongSoftwoodLumberShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Long Softwood Veneer Shelf',
      'nameID': 'LongSoftwoodVeneerShelfItem',
      'tag': false,
      'imageFile': 'LongSoftwoodVeneerShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Long Steel Shelf',
      'nameID': 'LongSteelShelfItem',
      'tag': false,
      'imageFile': 'LongSteelShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Long Thin Hardwood Veneer Shelf',
      'nameID': 'LongThinHardwoodVeneerShelfItem',
      'tag': false,
      'imageFile': 'LongThinHardwoodVeneerShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Long Thin Softwood Veneer Shelf',
      'nameID': 'LongThinSoftwoodVeneerShelfItem',
      'tag': false,
      'imageFile': 'LongThinSoftwoodVeneerShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Long Thin Wood Veneer Shelf',
      'nameID': 'LongThinWoodVeneerShelfItem',
      'tag': false,
      'imageFile': 'LongThinWoodVeneerShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Long Wood Veneer Shelf',
      'nameID': 'LongWoodVeneerShelfItem',
      'tag': false,
      'imageFile': 'LongWoodVeneerShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Lumber Hallway Table',
      'nameID': 'LumberHallwayTableItem',
      'tag': false,
      'imageFile': 'LumberHallwayTableObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Lupine',
      'nameID': 'LupineItem',
      'tag': false,
      'imageFile': 'LupineItem_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Medium Lumber Store Window',
      'nameID': 'MediumLumberStoreWindowItem',
      'tag': false,
      'imageFile': 'MediumLumberStoreWindowObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Norse Axe',
      'nameID': 'NorseAxeItem',
      'tag': false,
      'imageFile': 'NorseAxe_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Orrery',
      'nameID': 'OrreryItem',
      'tag': false,
      'imageFile': 'OrreryObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Participation Trophy',
      'nameID': 'ParticipationTrophyItem',
      'tag': false,
      'imageFile': 'ParticipationTrophyObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Refrigerated Display Cabinet',
      'nameID': 'RefrigeratedDisplayCabinetItem',
      'tag': false,
      'imageFile': 'RefrigeratedDisplayCabinetObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Rose',
      'nameID': 'RoseItem',
      'tag': false,
      'imageFile': 'RoseItem_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Rose Seed',
      'nameID': 'RoseSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Rotating Cube',
      'nameID': 'RotatingCubeItem',
      'tag': false,
      'imageFile': 'RotatingCubeObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Saved The World Achievement Trophy',
      'nameID': 'SavedTheWorldAchievementTrophyItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Short Basic Hardwood Shelf',
      'nameID': 'ShortBasicHardwoodShelfItem',
      'tag': false,
      'imageFile': 'ShortBasicHardwoodShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Short Basic Softwood Shelf',
      'nameID': 'ShortBasicSoftwoodShelfItem',
      'tag': false,
      'imageFile': 'UI_Icons_06.webp',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Short Basic Wood Shelf',
      'nameID': 'ShortBasicWoodShelfItem',
      'tag': false,
      'imageFile': 'ShortBasicSoftwoodShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Short Curved Hardwood Veneer Shelf',
      'nameID': 'ShortCurvedHardwoodVeneerShelfItem',
      'tag': false,
      'imageFile': 'ShortCurvedHardwoodVeneerShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Short Curved Softwood Veneer Shelf',
      'nameID': 'ShortCurvedSoftwoodVeneerShelfItem',
      'tag': false,
      'imageFile': 'ShortCurvedSoftwoodVeneerShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Short Curved Wood Veneer Shelf',
      'nameID': 'ShortCurvedWoodVeneerShelfItem',
      'tag': false,
      'imageFile': 'ShortCurvedWoodVeneerShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Short Floating Hardwood Shelf',
      'nameID': 'ShortFloatingHardwoodShelfItem',
      'tag': false,
      'imageFile': 'ShortFloatingHardwoodShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Short Floating Softwood Shelf',
      'nameID': 'ShortFloatingSoftwoodShelfItem',
      'tag': false,
      'imageFile': 'ShortFloatingSoftwoodShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Short Floating Wood Shelf',
      'nameID': 'ShortFloatingWoodShelfItem',
      'tag': false,
      'imageFile': 'ShortFloatingWoodShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Short Hardwood Veneer Shelf',
      'nameID': 'ShortHardwoodVeneerShelfItem',
      'tag': false,
      'imageFile': 'ShortHardwoodVeneerShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Short Softwood Veneer Shelf',
      'nameID': 'ShortSoftwoodVeneerShelfItem',
      'tag': false,
      'imageFile': 'ShortSoftwoodVeneerShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Short Steel Shelf',
      'nameID': 'ShortSteelShelfItem',
      'tag': false,
      'imageFile': 'ShortSteelShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Short Thin Hardwood Veneer Shelf',
      'nameID': 'ShortThinHardwoodVeneerShelfItem',
      'tag': false,
      'imageFile': 'ShortThinHardwoodVeneerShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Short Thin Softwood Veneer Shelf',
      'nameID': 'ShortThinSoftwoodVeneerShelfItem',
      'tag': false,
      'imageFile': 'ShortThinSoftwoodVeneerShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Short Thin Wood Veneer Shelf',
      'nameID': 'ShortThinWoodVeneerShelfItem',
      'tag': false,
      'imageFile': 'ShortThinWoodVeneerShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Short Wood Veneer Shelf',
      'nameID': 'ShortWoodVeneerShelfItem',
      'tag': false,
      'imageFile': 'ShortWoodVeneerShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Clay Pot',
      'nameID': 'SmallClayPotItem',
      'tag': false,
      'imageFile': 'SmallClayPotObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Faceted Steel Pot',
      'nameID': 'SmallFacetedSteelPotItem',
      'tag': false,
      'imageFile': 'SmallFacetedSteelPotObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Lumber Store Window',
      'nameID': 'SmallLumberStoreWindowItem',
      'tag': false,
      'imageFile': 'SmallLumberStoreWindowObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Rough Basalt Pot',
      'nameID': 'SmallRoughBasaltPotItem',
      'tag': false,
      'imageFile': 'SmallRoughBasaltPotObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Rough Limestone Pot',
      'nameID': 'SmallRoughLimestonePotItem',
      'tag': false,
      'imageFile': 'SmallRoughLimestonePotObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Round Limestone Pot',
      'nameID': 'SmallRoundLimestonePotItem',
      'tag': false,
      'imageFile': 'SmallRoundLimestonePotObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Square Basalt Pot',
      'nameID': 'SmallSquareBasaltPotItem',
      'tag': false,
      'imageFile': 'SmallSquareBasaltPotObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Square Clay Pot',
      'nameID': 'SmallSquareClayPotItem',
      'tag': false,
      'imageFile': 'SmallSquareClayPotObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Square Limestone Pot',
      'nameID': 'SmallSquareLimestonePotItem',
      'tag': false,
      'imageFile': 'SmallSquareLimestonePotObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Steel Pot',
      'nameID': 'SmallSteelPotItem',
      'tag': false,
      'imageFile': 'SmallSteelPotObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Small Stump Store Window',
      'nameID': 'SmallStumpStoreWindowItem',
      'tag': false,
      'imageFile': 'SmallStumpStoreWindowObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Softwood Double Shelf',
      'nameID': 'SoftwoodDoubleShelfItem',
      'tag': false,
      'imageFile': 'SoftwoodDoubleShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Softwood Lumber Hallway Table',
      'nameID': 'SoftwoodLumberHallwayTableItem',
      'tag': false,
      'imageFile': 'SoftwoodLumberHallwayTableObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Square Lumber Pot',
      'nameID': 'SquareLumberPotItem',
      'tag': false,
      'imageFile': 'SquareLumberPotObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Standing Basalt Pot',
      'nameID': 'StandingBasaltPotItem',
      'tag': false,
      'imageFile': 'StandingBasaltPotObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Standing Clay Pot',
      'nameID': 'StandingClayPotItem',
      'tag': false,
      'imageFile': 'StandingClayPotObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Tall Limestone Pot',
      'nameID': 'TallLimestonePotItem',
      'tag': false,
      'imageFile': 'TallLimestonePotObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Trophy Artist',
      'nameID': 'TrophyArtistItem',
      'tag': false,
      'imageFile': 'TrophyArtistObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Trophy Baker',
      'nameID': 'TrophyBakerItem',
      'tag': false,
      'imageFile': 'TrophyBakerObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Trophy Farmer',
      'nameID': 'TrophyFarmerItem',
      'tag': false,
      'imageFile': 'TrophyFarmerObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Trophy Logger',
      'nameID': 'TrophyLoggerItem',
      'tag': false,
      'imageFile': 'TrophyLoggerObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Trophy Miner',
      'nameID': 'TrophyMinerItem',
      'tag': false,
      'imageFile': 'TrophyMinerObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Tulip',
      'nameID': 'TulipItem',
      'tag': false,
      'imageFile': 'TulipItem_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Tulip Seed',
      'nameID': 'TulipSeedItem',
      'tag': false,
      'imageFile': 'UI_Icons_00.webp',
      'xPos': 6,
      'yPos': 15
    },
    {
      'name': 'Wood Double Shelf',
      'nameID': 'WoodDoubleShelfItem',
      'tag': false,
      'imageFile': 'WoodDoubleShelfObject_Icon.png',
      'xPos': 0,
      'yPos': 0
    },
    {
      'name': 'Advanced Baking Skill Book',
      'nameID': 'AdvancedBakingSkillBook',
      'tag': false
    },
    {
      'name': 'Advanced Cooking Skill Book',
      'nameID': 'AdvancedCookingSkillBook',
      'tag': false
    },
    {
      'name': 'Advanced Masonry Skill Book',
      'nameID': 'AdvancedMasonrySkillBook',
      'tag': false
    },
    {
      'name': 'Advanced Smelting Skill Book',
      'nameID': 'AdvancedSmeltingSkillBook',
      'tag': false
    },
    {
      'name': 'Baking Skill Book',
      'nameID': 'BakingSkillBook',
      'tag': false
    },
    {
      'name': 'Basic Engineering Skill Book',
      'nameID': 'BasicEngineeringSkillBook',
      'tag': false
    },
    {
      'name': 'Blacksmith Skill Book',
      'nameID': 'BlacksmithSkillBook',
      'tag': false
    },
    {
      'name': 'Butchery Skill Book',
      'nameID': 'ButcherySkillBook',
      'tag': false
    },
    {
      'name': 'Carpentry Skill Book',
      'nameID': 'CarpentrySkillBook',
      'tag': false
    },
    {
      'name': 'Composites Skill Book',
      'nameID': 'CompositesSkillBook',
      'tag': false
    },
    {
      'name': 'Cooking Skill Book',
      'nameID': 'CookingSkillBook',
      'tag': false
    },
    {
      'name': 'Cutting Edge Cooking Skill Book',
      'nameID': 'CuttingEdgeCookingSkillBook',
      'tag': false
    },
    {
      'name': 'Electronics Skill Book',
      'nameID': 'ElectronicsSkillBook',
      'tag': false
    },
    {
      'name': 'Farming Skill Book',
      'nameID': 'FarmingSkillBook',
      'tag': false
    },
    {
      'name': 'Fertilizers Skill Book',
      'nameID': 'FertilizersSkillBook',
      'tag': false
    },
    {
      'name': 'Glassworking Skill Book',
      'nameID': 'GlassworkingSkillBook',
      'tag': false
    },
    {
      'name': 'Industry Skill Book',
      'nameID': 'IndustrySkillBook',
      'tag': false
    },
    {
      'name': 'Masonry Skill Book',
      'nameID': 'MasonrySkillBook',
      'tag': false
    },
    {
      'name': 'Mechanics Skill Book',
      'nameID': 'MechanicsSkillBook',
      'tag': false
    },
    {
      'name': 'Milling Skill Book',
      'nameID': 'MillingSkillBook',
      'tag': false
    },
    {
      'name': 'Oil Drilling Skill Book',
      'nameID': 'OilDrillingSkillBook',
      'tag': false
    },
    {
      'name': 'Painting Skill Book',
      'nameID': 'PaintingSkillBook',
      'tag': false
    },
    {
      'name': 'Paper Milling Skill Book',
      'nameID': 'PaperMillingSkillBook',
      'tag': false
    },
    {
      'name': 'Pottery Skill Book',
      'nameID': 'PotterySkillBook',
      'tag': false
    },
    {
      'name': 'Shipwright Skill Book',
      'nameID': 'ShipwrightSkillBook',
      'tag': false
    },
    {
      'name': 'Smelting Skill Book',
      'nameID': 'SmeltingSkillBook',
      'tag': false
    },
    {
      'name': 'Tailoring Skill Book',
      'nameID': 'TailoringSkillBook',
      'tag': false
    },
    {
      'name': 'Advanced Baking Skill Scroll',
      'nameID': 'AdvancedBakingSkillScroll',
      'tag': false
    },
    {
      'name': 'Advanced Cooking Skill Scroll',
      'nameID': 'AdvancedCookingSkillScroll',
      'tag': false
    },
    {
      'name': 'Advanced Masonry Skill Scroll',
      'nameID': 'AdvancedMasonrySkillScroll',
      'tag': false
    },
    {
      'name': 'Advanced Smelting Skill Scroll',
      'nameID': 'AdvancedSmeltingSkillScroll',
      'tag': false
    },
    {
      'name': 'Baking Skill Scroll',
      'nameID': 'BakingSkillScroll',
      'tag': false
    },
    {
      'name': 'Basic Engineering Skill Scroll',
      'nameID': 'BasicEngineeringSkillScroll',
      'tag': false
    },
    {
      'name': 'Blacksmith Skill Scroll',
      'nameID': 'BlacksmithSkillScroll',
      'tag': false
    },
    {
      'name': 'Butchery Skill Scroll',
      'nameID': 'ButcherySkillScroll',
      'tag': false
    },
    {
      'name': 'Carpentry Skill Scroll',
      'nameID': 'CarpentrySkillScroll',
      'tag': false
    },
    {
      'name': 'Composites Skill Scroll',
      'nameID': 'CompositesSkillScroll',
      'tag': false
    },
    {
      'name': 'Cooking Skill Scroll',
      'nameID': 'CookingSkillScroll',
      'tag': false
    },
    {
      'name': 'Cutting Edge Cooking Skill Scroll',
      'nameID': 'CuttingEdgeCookingSkillScroll',
      'tag': false
    },
    {
      'name': 'Electronics Skill Scroll',
      'nameID': 'ElectronicsSkillScroll',
      'tag': false
    },
    {
      'name': 'Farming Skill Scroll',
      'nameID': 'FarmingSkillScroll',
      'tag': false
    },
    {
      'name': 'Fertilizers Skill Scroll',
      'nameID': 'FertilizersSkillScroll',
      'tag': false
    },
    {
      'name': 'Glassworking Skill Scroll',
      'nameID': 'GlassworkingSkillScroll',
      'tag': false
    },
    {
      'name': 'Industry Skill Scroll',
      'nameID': 'IndustrySkillScroll',
      'tag': false
    },
    {
      'name': 'Masonry Skill Scroll',
      'nameID': 'MasonrySkillScroll',
      'tag': false
    },
    {
      'name': 'Mechanics Skill Scroll',
      'nameID': 'MechanicsSkillScroll',
      'tag': false
    },
    {
      'name': 'Milling Skill Scroll',
      'nameID': 'MillingSkillScroll',
      'tag': false
    },
    {
      'name': 'Oil Drilling Skill Scroll',
      'nameID': 'OilDrillingSkillScroll',
      'tag': false
    },
    {
      'name': 'Painting Skill Scroll',
      'nameID': 'PaintingSkillScroll',
      'tag': false
    },
    {
      'name': 'Paper Milling Skill Scroll',
      'nameID': 'PaperMillingSkillScroll',
      'tag': false
    },
    {
      'name': 'Pottery Skill Scroll',
      'nameID': 'PotterySkillScroll',
      'tag': false
    },
    {
      'name': 'Shipwright Skill Scroll',
      'nameID': 'ShipwrightSkillScroll',
      'tag': false
    },
    {
      'name': 'Smelting Skill Scroll',
      'nameID': 'SmeltingSkillScroll',
      'tag': false
    },
    {
      'name': 'Tailoring Skill Scroll',
      'nameID': 'TailoringSkillScroll',
      'tag': false
    },
    {
      'name': 'Claim Paper Item',
      'nameID': 'ClaimPaperItem',
      'tag': false
    },
    {
      'name': 'Homestead Support Claim Paper',
      'nameID': 'HomesteadSupportClaimPaperItem',
      'tag': false
    },
    {
      'name': 'Picture Item',
      'nameID': 'PictureItem',
      'tag': false
    },
    {
      'name': 'Hands',
      'nameID': 'HandsItem',
      'tag': false
    },
    {
      'name': 'Country Claim Stake',
      'nameID': 'CountryClaimStakeItem',
      'tag': false
    },
    {
      'name': 'Federation Claim Stake',
      'nameID': 'FederationClaimStakeItem',
      'tag': false
    },
    {
      'name': 'Outpost Claim Stake Item',
      'nameID': 'OutpostClaimStakeItem',
      'tag': false
    },
    {
      'name': 'School Supply Station Item',
      'nameID': 'SchoolSupplyStationItem',
      'tag': false
    },
    {
      'name': 'Starter Camp',
      'nameID': 'StarterCampItem',
      'tag': false
    },
    {
      'name': 'Students Desk Item',
      'nameID': 'StudentsDeskItem',
      'tag': false
    },
    {
      'name': 'Teachers Desk Item',
      'nameID': 'TeachersDeskItem',
      'tag': false
    },
    {
      'name': 'Town Claim Stake',
      'nameID': 'TownClaimStakeItem',
      'tag': false
    }
  ];

export const items: Map<string, Item> = new Map(itemsArray.map(
  item => [item.nameID, new Item(item)]
));
